/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const ConnectedIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-connected-world"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-connected-world:not(.animated) .animable {opacity: 0;}svg#freepik_stories-connected-world.animated #freepik--background-complete--inject-103 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-connected-world.animated #freepik--Earth--inject-103 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-connected-world.animated #freepik--character-3--inject-103 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-connected-world.animated #freepik--character-2--inject-103 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-connected-world.animated #freepik--character-1--inject-103 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-103"
        style={{ transformOrigin: '236.79750442504883px 252.32473182678223px' }}
        className="animable"
      >
        <path
          d="M436,50.89c.61-4.47-5.7-8.15-10.44-8.53-2.27-.18-4.61.16-6.76-.58-4.64-1.62-6.49-7.62-11-9.53-3.39-1.43-7.29-.16-10.57,1.5s-6.53,3.73-10.2,4c-3.19.21-6.65-1-9.44.58-2.08,1.16-3.17,3.56-5.09,5s-4.32,1.68-6.65,1.81-4.74.15-6.86,1.12-3.87,3.21-3.43,5.5Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '395.7664108276367px 41.694756507873535px',
          }}
          id="el4jr0glf2ohp"
          className="animable"
        />
        <path
          d="M419.45,95a9,9,0,1,1-11.53-5.42A9,9,0,0,1,419.45,95Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '410.9803190231323px 98.04494953155518px',
          }}
          id="el0fptg3q680oa"
          className="animable"
        />
        <path
          d="M437.07,69.43A9,9,0,1,1,425.54,64,9,9,0,0,1,437.07,69.43Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '428.5971336364746px 72.46607780456543px',
          }}
          id="elda7xqlgkhbi"
          className="animable"
        />
        <path
          d="M450,105.35c1.84,5.1-.46,10.59-5.14,12.28s-10-1.06-11.8-6.16.46-10.59,5.14-12.28S448.2,100.26,450,105.35Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '441.5382242202759px 108.41047859191895px',
          }}
          id="el86ahswg0px"
          className="animable"
        />
        <path
          d="M438.68,108.23c-.17.66-7-.51-15.17-2.63s-14.72-4.36-14.55-5,7,.51,15.17,2.62S438.85,107.56,438.68,108.23Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '423.8199939727783px 104.418692111969px',
          }}
          id="elkr5xdisgavi"
          className="animable"
        />
        <path
          d="M426.61,72.54c.58.37-2.33,6-6.49,12.51s-8,11.54-8.57,11.17,2.32-6,6.48-12.5S426,72.17,426.61,72.54Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '419.0809359550476px 84.38003730773926px',
          }}
          id="el1gkcd228lfu"
          className="animable"
        />
        <path
          d="M69.22,112.6a4.5,4.5,0,1,1-4.47-4.52A4.49,4.49,0,0,1,69.22,112.6Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '64.72007083892822px 112.57990455627441px',
          }}
          id="ellme09uzyqo"
          className="animable"
        />
        <path
          d="M55.74,106.82a12.47,12.47,0,0,1,18-.24c2.29,2.31,5.88-1.24,3.59-3.56a17.56,17.56,0,0,0-25.17.21c-2.25,2.35,1.3,6,3.55,3.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '64.75289058685303px 102.71058750152588px',
          }}
          id="el7sf9g7sifi9"
          className="animable"
        />
        <path
          d="M40.48,85.9c6.83-5.91,15-9.63,24.13-9.65a35.79,35.79,0,0,1,24.62,9.42c2.37,2.22,6-1.33,3.59-3.56A41,41,0,0,0,64.63,71.19c-10.51,0-19.86,4.32-27.71,11.12C34.45,84.44,38,88,40.48,85.9Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '64.84852600097656px 78.86437463760376px',
          }}
          id="eljc9i1sw3mtg"
          className="animable"
        />
        <path
          d="M46.5,97.49A24.73,24.73,0,0,1,82.84,97c2.27,2.34,5.87-1.22,3.59-3.56a29.77,29.77,0,0,0-43.49.49c-2.2,2.38,1.35,6,3.56,3.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '64.70273208618164px 91.27957201004028px',
          }}
          id="el3a1t4tqfmcn"
          className="animable"
        />
        <path
          d="M119.13,452.59c2.93-6.85,1.15-14-3.67-19.66a20.61,20.61,0,0,0-20.17-6.55,22.56,22.56,0,0,0-34-15.25,23,23,0,0,0-10.72,18.16A16.89,16.89,0,0,0,37.66,452.2Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '78.50640106201172px 430.1957492828369px',
          }}
          id="el3lzyp2sv5he"
          className="animable"
        />
        <polygon
          points="71.97 452.35 71.97 440.88 66.22 440.88 74.87 428.67 83.52 440.79 77.88 440.79 77.88 452.35 71.97 452.35"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '74.86999893188477px 440.510009765625px',
          }}
          id="el4r7q9r0drnl"
          className="animable"
        />
        <path
          d="M452.13,436.2a15.12,15.12,0,0,1-11.74-1.62,26.65,26.65,0,0,1-8.64-8.43c-4.43-6.5-6.21-15.37-6.66-23.22,8.73.06,16.41,6.66,20.09,10.25,5.83,5.68,12.91,19.48,6.95,23"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '439.7385721206665px 419.8300895690918px',
          }}
          id="elkgt95dke9"
          className="animable"
        />
        <path
          d="M410.89,398.15a12.93,12.93,0,0,1,4.84,12,17.11,17.11,0,0,1-7,11.24c-1.69,1.25-3.8,2.26-5.83,1.74a5.54,5.54,0,0,1-3.72-4.19,11.12,11.12,0,0,1,.48-5.79c2-6.43,5.08-12.29,11.23-15"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '407.42755222320557px 410.7098112106323px',
          }}
          id="elh7d9a3i4me9"
          className="animable"
        />
        <path
          d="M405,379.39a25.78,25.78,0,0,1,2.66,4.46,23.94,23.94,0,0,1,2,5.32A52.15,52.15,0,0,1,411,396a25.79,25.79,0,0,1-1.43,12.48,18.07,18.07,0,0,1-1.79,3.39,4.42,4.42,0,0,1-.9,1.07c-.14-.09,1.06-1.69,2.11-4.68a27.61,27.61,0,0,0,1.14-12.16,64.66,64.66,0,0,0-1.29-6.69,27,27,0,0,0-1.75-5.26A35.67,35.67,0,0,1,405,379.39Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '408.1120593547821px 396.16502380371094px',
          }}
          id="eljlcpgkqc5wc"
          className="animable"
        />
        <path
          d="M445.81,426.17a15.58,15.58,0,0,1-1.9-1.82c-1.19-1.2-2.88-3-5-5.17-4.14-4.4-9.78-10.55-15.86-17.5S411.71,388.3,408,383.55c-1.87-2.37-3.37-4.3-4.37-5.66a15.79,15.79,0,0,1-1.5-2.16,14.41,14.41,0,0,1,1.77,1.95l4.59,5.48c3.87,4.64,9.25,11,15.32,17.94l15.65,17.66c1.92,2.17,3.51,4,4.74,5.36A15,15,0,0,1,445.81,426.17Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '423.97003173828125px 400.9499969482422px',
          }}
          id="elf7p76ax0k9f"
          className="animable"
        />
        <path
          d="M416.45,389.4a30.18,30.18,0,0,0,27.5,2.25c2.25-.95,4.66-2.65,4.63-5.09s-2.51-4.08-4.8-4.92a25.8,25.8,0,0,0-27.71,7.22"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '432.32515144348145px 387.0852165222168px',
          }}
          id="el08vni5afnb66"
          className="animable"
        />
        <path
          d="M437.7,388.21a4,4,0,0,1-1.29.51c-.84.28-2.08.6-3.63,1a34,34,0,0,1-12.41.64,21.41,21.41,0,0,1-6.55-2.18,20.54,20.54,0,0,1-4.53-3.33,20.15,20.15,0,0,1-2.46-2.87c-.52-.72-.78-1.14-.73-1.18s1.29,1.5,3.61,3.59a22.34,22.34,0,0,0,4.49,3.07,22,22,0,0,0,6.31,2,38.37,38.37,0,0,0,12.15-.38A47.23,47.23,0,0,1,437.7,388.21Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '421.8969717025757px 385.7281093597412px',
          }}
          id="elpgldctl07je"
          className="animable"
        />
        <path
          d="M136.38,47.57c.39-2.86-3.65-5.22-6.69-5.46-1.45-.12-3,.1-4.32-.38-3-1-4.17-4.87-7.07-6.1-2.17-.91-4.66-.1-6.77,1S107.35,39,105,39.13c-2,.13-4.26-.63-6,.37-1.33.75-2,2.28-3.26,3.19a7.81,7.81,0,0,1-4.26,1.15,12,12,0,0,0-4.39.72,3.47,3.47,0,0,0-2.2,3.52Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '110.64216995239258px 41.658385276794434px',
          }}
          id="elvsiap69ip4"
          className="animable"
        />
        <path
          d="M421.5,458.5c.4-2.86-3.65-5.22-6.69-5.47-1.44-.11-2.95.11-4.32-.37-3-1-4.16-4.88-7.06-6.1-2.17-.92-4.67-.1-6.77,1s-4.19,2.39-6.54,2.54c-2,.13-4.26-.63-6.05.37-1.33.74-2,2.28-3.25,3.18a7.76,7.76,0,0,1-4.26,1.16,12.07,12.07,0,0,0-4.4.72A3.45,3.45,0,0,0,370,459Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '395.75855255126953px 452.5811839103699px',
          }}
          id="eln8qs1vnws0s"
          className="animable"
        />
        <path
          d="M70.75,149c.4-2.87-3.65-5.22-6.68-5.47-1.45-.11-3,.11-4.33-.37-3-1-4.16-4.88-7.06-6.1-2.17-.92-4.67-.1-6.77.95s-4.18,2.4-6.53,2.55c-2.05.13-4.27-.63-6.06.37-1.33.74-2,2.28-3.25,3.18a7.76,7.76,0,0,1-4.26,1.16,12,12,0,0,0-4.39.71,3.48,3.48,0,0,0-2.2,3.53Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '44.992679595947266px 143.08547496795654px',
          }}
          id="el71cmh0bpfao"
          className="animable"
        />
        <path
          d="M180.11,472.46c.39-2.87-3.65-5.22-6.69-5.47-1.45-.12-2.95.11-4.33-.37-3-1-4.16-4.88-7.06-6.1-2.17-.92-4.67-.11-6.77,1s-4.18,2.39-6.53,2.54c-2,.13-4.26-.62-6,.38-1.33.74-2,2.27-3.26,3.18a7.73,7.73,0,0,1-4.26,1.15,12.23,12.23,0,0,0-4.39.72,3.48,3.48,0,0,0-2.2,3.53Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '154.37206840515137px 466.57019662857056px',
          }}
          id="elqw12sxwarm"
          className="animable"
        />
      </g>
      <g
        id="freepik--Earth--inject-103"
        style={{ transformOrigin: '256.2607879638672px 261.81009674072266px' }}
        className="animable"
      >
        <path
          d="M446.47,239c-.21-2.16-.46-4.28-.76-6.4s-.63-4.48-1-6.7q.57,3.33,1,6.7C446,234.72,446.26,236.84,446.47,239Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '445.5899963378906px 232.45000457763672px',
          }}
          id="el250cqhyre3b"
          className="animable"
        />
        <path
          d="M429.11,265.53c-1.87-4.19-2.3-8.82-3.54-13.22-.66-2.36-1.78-4.88-4-5.92-1.48-.69-3.23-.6-4.8-1.08-5.66-1.68-7.2-9.48-12.55-11.91a18.67,18.67,0,0,0-5.39-1.1c-7.16-.84-14.57-3.29-19.07-8.86-1.49-1.79-2.61-3.91-4.42-5.38s-4.69-2.09-6.47-.6c1.51,3,3,6,4.48,8.95,1.36,2.69,2.75,5.47,5,7.44s5.69,3.05,8.44,1.8c.91-.42,1.82-1.11,2.84-1a3.09,3.09,0,0,1,1.85,1.17c3.9,4.27,2.63,11.36-1.18,15.73s-9.41,6.61-14.82,8.73c-1.93.75-4,1.53-6.05,1.17-3.74-.69-5.74-4.72-6.83-8.34-2.45-8-3.63-16.72-8.65-23.48-1.6-2.13-3.59-4.07-4.56-6.55-1-2.7-.79-5.84-2.42-8.2s-5.29-3.92-5.53-6.91c-.16-2.09,1.6-3.95,3.53-4.84s4.12-1.2,6.11-2c.79-.33,1.66-.9,1.69-1.73,0-1.26-1.75-1.77-2.2-2.93-.49-1.32.87-2.55,1.45-3.83,1.24-2.93-1.85-5.9-4.84-7.09s-6.56-2.07-7.95-4.94a16.57,16.57,0,0,1-1-4.27c-.69-3.62-3.39-7.12-7.07-7.72s-7.84,2.66-7.23,6.31c.36,2,1.87,3.56,2.69,5.41s.6,4.61-1.33,5.21c-3.18,1-6.23-4.79-8.89-2.81,1.09,3.68,2.15,7.35,3.24,11.06-4.18,2.1-9.17-1.7-11-6s-1.85-9.18-4-13.31-7.83-7.24-11.46-4.31c-.18,5.33,6.92,7.48,10.07,11.79,2.26,3.11,1.93,8.16-1.42,10.14s-8.62-1.47-7.35-5.09c.45-1.25,1.51-2.3,1.63-3.65.12-1.67-1.3-3-2.6-4.09-2-1.71-4.05-3.38-6.08-5.06a12.91,12.91,0,0,0-4.32-2.69c-4.17-1.2-8.35,2.15-10.55,5.83s-3.45,8.05-6.5,11.13c-4.39,4.49-12.7,4.75-16.82.06s-2-13.49,4.06-15.19c2.29-.63,5.2-.57,6.41-2.58,2.11-3.56-3.94-8.1-1.85-11.69,1.6-2.75,5.84-1.5,8.92-2.43s4.78-4,6.59-6.6,4.6-5.24,7.74-4.55c-.24-1.83-.48-3.8.34-5.45s3.11-2.75,4.62-1.67c-1.54,2.51.3,6,3,7.27s5.83,1,8.79.63,6.69-1.44,6.93-4.37c.09-1-.27-2,.09-2.87,1.3-3.5,7.83,1.31,10.34-1.5,1.45-1.46-.15-4.07-2.18-4.54s-4.08.23-6.13.3-4.57-1-4.66-3,2.18-3.44,2.42-5.41c.39-3.35-5.35-4.22-7.38-1.5s-1.3,6.47-.69,9.79.93,7.23-1.55,9.57c-1.06,1.58-3.81.74-4.71-.93s-.73-3.71-.88-5.59-1-4.07-2.87-4.58c-1.3-.36-2.69.27-4,.45-5.27.63-8.92-6.1-7.26-11.07s6.41-8.19,11-10.74c3.39-1.85,7.59-3.59,10.95-1.7,1.57.87,2.66,2.36,4.2,3.26,2.66,1.55,6,1,9,1.05a21.14,21.14,0,0,1,13.16,5c1.36,1.23,2.63,3.26,1.57,4.73s-4.44,1.88-3.87,3.71a6.56,6.56,0,0,0,8.22-5.24,5.44,5.44,0,0,1,3.18,4.43c3.84-3.86,11.22-3.29,14.36,1.16.85,1.17,1.45,2.58,2.66,3.38s3.33.39,3.48-1a2.87,2.87,0,0,0-.24-1.32c-.73-2-1.48-4-2.21-6,2.81-1.5,6.14.84,8,3.35,7.08,9.36,12.13,3.74,22.11,5.26,6.74,1,9.7,5.3,13.51,10.47,11.67,15.91,27.09,29,37.71,45.59,1.12,1.73,2.14,3.49,3.11,5.29-.18-.45-.33-.9-.51-1.35a184.75,184.75,0,0,0-15.42-31q-2-3.15-4-6.19c-.85-1.26-1.73-2.55-2.6-3.77-1.12-1.62-2.3-3.17-3.48-4.73-.94-1.26-1.88-2.48-2.85-3.68-.66-.84-1.36-1.67-2.05-2.51s-1.51-1.88-2.36-2.81l-2.54-2.9a9.55,9.55,0,0,0-.82-.9c-.87-1-1.81-2-2.75-3a.85.85,0,0,0-.27-.3c-.24-.27-.51-.54-.79-.81-.75-.84-1.57-1.64-2.35-2.45-1.3-1.32-2.63-2.63-4-3.89-1.11-1.11-2.26-2.15-3.44-3.2s-2.06-1.85-3.12-2.75-2.05-1.77-3.11-2.63c-1.27-1.08-2.57-2.13-3.9-3.17h0q-5.49-4.36-11.31-8.23c-1-.66-1.91-1.29-2.87-1.91s-2-1.26-2.94-1.86-2-1.22-3-1.79-2-1.2-3-1.77c-.82-.48-1.6-.93-2.42-1.34a12.81,12.81,0,0,0-1.24-.69c-1.72-1-3.48-1.89-5.23-2.75-.88-.45-1.76-.9-2.66-1.32-1.12-.57-2.27-1.11-3.42-1.61a2.66,2.66,0,0,0-.51-.24c-1-.48-2.06-1-3.12-1.41-1.48-.63-3-1.26-4.44-1.85-1.7-.69-3.39-1.38-5.11-2-1.91-.72-3.81-1.4-5.75-2s-3.9-1.29-5.86-1.89-3.93-1.13-5.93-1.67c-3.93-1-7.92-2-11.94-2.78-.06,0-.15,0-.22-.06-1.54-.3-3.08-.6-4.62-.84a1.32,1.32,0,0,0-.3-.06c-.67-.12-1.36-.24-2.06-.33-2.87-.48-5.78-.87-8.71-1.2-.33-.06-.69-.09-1.06-.12-.84-.11-1.69-.17-2.57-.26q-2.89-.27-5.83-.45c-2-.15-4.08-.24-6.14-.3s-4.29-.12-6.44-.12c-5.69,0-11.31.24-16.87.75-1.33.09-2.63.21-3.93.36s-2.72.29-4.09.47-2.72.36-4,.57-2.69.42-4.05.66c-1.15.18-2.33.39-3.48.63-2.84.54-5.65,1.13-8.43,1.79q-2,.45-3.9,1c-1.3.33-2.6.69-3.87,1-2.15.59-4.24,1.25-6.32,1.91h0c-1.7.57-3.42,1.14-5.08,1.71a.31.31,0,0,0-.12,0c-1.73.6-3.39,1.23-5.08,1.89l-.28.09c-1.54.6-3.08,1.23-4.59,1.85-1.91.78-3.78,1.62-5.63,2.46-1.57.71-3.11,1.43-4.62,2.18s-3.27,1.62-4.87,2.45l-.18.09c-1.54.81-3.09,1.65-4.6,2.51s-3.11,1.77-4.65,2.73h0c-1.46.86-2.88,1.73-4.3,2.63-.54.33-1.06.69-1.6,1.05-1.51.95-3,1.94-4.45,3-1.81,1.22-3.56,2.51-5.32,3.8-1.54,1.13-3,2.3-4.53,3.47a188.55,188.55,0,0,0-23.77,22.28c-2.57,2.81-5,5.68-7.35,8.61-2,2.52-3.93,5.06-5.77,7.69-1.66,2.29-3.27,4.62-4.81,7,1.54-2.37,3.15-4.7,4.81-7,.48-.06,1-.12,1.45-.15,2.72-.21,5.59-.12,8-1.29,2.27-1.1,3.87-3.11,5.93-4.54,5.26-3.71,13.88-4.4,15.3-10.62.48-2.09-.09-4.37.69-6.37,1.49-3.74,6.54-4.28,10.59-4.22,1.72,0,3.75.24,4.53,1.74a4.23,4.23,0,0,1-.18,3.47A32.57,32.57,0,0,1,133,143.31c-5.26,3.18-12.12,5.63-13.57,11.55.72,2,4.41,1.85,4.71,3.95.22,1.67-2,2.54-2.75,4-1.15,2.18,1.48,4.84,4,4.72s4.6-1.91,6.44-3.59c5.51-5,11.28-10.5,13.28-17.67.84-3,1.15-6.43,3.56-8.41,2.88-2.33,8-.72,9,2.84,2.38-1.31,6.1-2.3,7.34.15a12.12,12.12,0,0,1,.52,2.81c.78,3.83,6.08,5.57,6.62,9.43.63,4.45-5.14,6.76-9.65,7.44-4.08.63-8.16,1.26-12.24,1.92a11.47,11.47,0,0,0-5.08,1.61c-1.45,1.08-2.36,3.11-1.51,4.7a11.91,11.91,0,0,0,2.11,2.15c3.39,3.35.61,10.26-4.17,10.41-1.63.06-3.24-.54-4.87-.6-4.84-.21-8.68,4-11,8.23s-4,9-7.9,11.9c-6.22,4.64-17,3.56-20,10.68-1.21,2.87-.58,6.1-.09,9.18s.69,6.46-1.12,9-6.44,3.05-7.77.24a6.74,6.74,0,0,1-.18-4q1.08-6.65,2.11-13.28c.52-3.29,1-7-1-9.66-2.75-3.77-8.92-3.41-12.48-.39s-5,7.74-6,12.26c-.73,3.35-1.57,8.08-3.45,11.9h0c-.63,3.71-1.15,7.48-1.54,11.28s-.67,7.75-.82,11.7a16.35,16.35,0,0,0,1.55-1.44c1.9-1.94,5.74-10.17,9.19-6.13a3,3,0,0,1,.06,3.74c-1.06,1.34-3.18,1.64-4,3.11-1,1.73.39,3.89,2,5S78,256,79.12,257.66c2.21,3.14.09,7.9,2.24,11.1,1.84,2.75,5.77,2.93,9.13,3.29l1.15.18c.94-6.58,4-11.94,13.12-14,12.52-2.81,29,7.45,36,16.78,7.86,10.44,11.58,25.21,23.62,30.45,8.62,3.74,20.86,2.39,25.06,10.74,3.75,7.47-2.78,15.88-3.77,24.16-.64,5.48,1.17,10.92,1.6,16.4S186,368.69,181,371c-2.81,1.26-6.35,1.11-8.62,3.2-4,3.77-.73,11.55-4.75,15.32-1.42,1.31-3.38,1.79-5.11,2.66-9,4.52-8.79,17.68-4.59,26.8l.45,1a192.72,192.72,0,0,0,98,26.77A191.79,191.79,0,0,0,346,424.62h0A190.2,190.2,0,0,0,363,414.54a187.67,187.67,0,0,0,23.74-18.66,183.26,183.26,0,0,0,14.51-15c3.21-3.65,6.23-7.44,9.14-11.33,1.48-2,2.93-4,4.29-6.07A183.38,183.38,0,0,0,426,344.61a187.48,187.48,0,0,0,19.65-61.52c.58-4.25,1-8.56,1.33-12.9a11,11,0,0,1-7.68,3.38C434.74,273.52,431,269.72,429.11,265.53Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '256.24000549316406px 257.7900695800781px',
          }}
          id="el9umdxyc04dh"
          className="animable"
        />
        <path
          d="M210.75,118.21c-3.79,2.24-5.8,6.46-8.72,9.73s-8.16,5.6-11.61,2.88a7.86,7.86,0,0,1-2.59-5.56,14.11,14.11,0,0,1,2.06-8.66c1.64-2.65,4.15-4.74,5.55-7.53s1.1-6.88-1.75-8.19c-1.54-.71-3.49-.43-4.86-1.43-2.46-1.79-.7-6,2.16-7.11s6-.24,9.09,0c11.08.7,19.22-6.47,27.55-12.43,6.47-4.63,20.27-10.11,27.76-5.37,3,1.89,4.16,6.74,1.34,8.88-1.26.95-3,1.16-4.17,2.22-1.41,1.27-1.61,3.35-2.41,5.06-2.1,4.43-8.14,6-10.09,10.54-1.17,2.71-.64,6.08-2.45,8.43-1.43,1.86-3.91,2.51-6.21,3L217,116.07A21.5,21.5,0,0,0,210.75,118.21Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '223.0008888244629px 102.36696434020996px',
          }}
          id="el214ny2lmery"
          className="animable"
        />
        <path
          d="M339.86,350.85c-4.79,7.14-5.66,16.07-7,24.54s-3.62,17.47-10.19,23.05-18.67,5.25-22.29-2.54c-2-4.23-1-9.21-2-13.74-1.39-5.9-6.14-10.46-8.4-16.1-1.92-4.8-1.93-10.12-2.08-15.29-.86-28.24-7.82-57.72-27.26-78.42-2.39-2.55-5.1-5-8.49-5.91a10.92,10.92,0,0,0-11.16,3.8c-1.56,2.05-2.36,4.65-4.27,6.38-4.16,3.75-11.41,1.06-14.19-3.78s-2.39-10.77-1.92-16.32q.85-10.3,1.73-20.62c.3-3.6.7-7.46,3.09-10.19,3.39-3.88,9.48-4.07,13.63-7.14,5.45-4,6.17-11.73,9.6-17.54s14.18-8.26,15.77-1.72c11.36-24.06,36.47,11.68,51.41,9,4.33-.79,8.57-2.85,12.94-2.24,7.7,1.06,11.68,9.47,14.31,16.72q6.53,18,13.06,36.09c1.66,4.59,3.8,9.68,8.39,11.44,3.51,1.35,7.6.32,11.14,1.6,9.37,3.37,6.33,18-1.21,24.41s-18.13,10.53-21.71,19.73c-2.7,6.94-.55,15.06-3.46,21.92C347.21,342.88,342.83,346.42,339.86,350.85Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '300.8960266113281px 296.59130859375px',
          }}
          id="el4i9aik9b0f8"
          className="animable"
        />
        <path
          d="M375.43,358.7c-3.08.42-6.71-1.08-9.05.94-1.37,1.19-1.67,3.13-2.21,4.84a10.36,10.36,0,0,1-4.37,5.89,6.62,6.62,0,0,1-7.12-.12c-2-1.51-2.62-4.72-1-6.6.75-.86,1.83-1.37,2.66-2.15,4.09-3.82,1.29-10.91,4.4-15.45,1.83-2.68,4.72-5.4,6.73-8.11,1.55-2.09,2.11-3.74,5-4.3C382.91,331.22,388.53,356.88,375.43,358.7Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '366.84086990356445px 352.41451835632324px',
          }}
          id="eltqbi92ti8cf"
          className="animable"
        />
        <path
          d="M90.28,307.4c-.61-5.41,1.21-10.82,1.3-16.3.06-3.77-.21-7.75-.27-11.54a52.92,52.92,0,0,1-9.71-1.35,2.88,2.88,0,0,1-1.78-.9,3.4,3.4,0,0,1-.4-2c-.24-4.25-4.38-7.06-8.1-9.18a31.81,31.81,0,0,0-5.9-2.87c0,.44,0,.86,0,1.31a186.54,186.54,0,0,0,12.16,60,180,180,0,0,0,11.67,24.77c1.87,3.44,3.93,6.82,6.08,10.14,2.66,4.1,5.44,8.1,8.43,12,2.79,3.71,5.75,7.33,8.86,10.8A190.73,190.73,0,0,0,126.17,396c4.2,3.89,8.59,7.56,13.15,11.06-10.43-27.69-20.26-56-38.1-79.53C96.54,321.34,91.15,315.06,90.28,307.4Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '102.3699951171875px 335.1600036621094px',
          }}
          id="elhntvcjhq0do"
          className="animable"
        />
        <path
          d="M91.67,272.23l-1.15-.18c-3.36-.36-7.29-.54-9.13-3.29-2.15-3.2,0-8-2.24-11.1C78,256,76,255.3,74.38,254.13s-3-3.29-2-5c.81-1.47,2.93-1.77,4-3.11a3,3,0,0,0-.06-3.74c-3.45-4-7.29,4.19-9.19,6.13a17.66,17.66,0,0,1-1.54,1.44v0c0,.35-.07.68-.07,1,0,1.12,0,2.27-.06,3.41s-.06,2.28-.06,3.41c0,.93,0,1.85,0,2.77s0,1.85,0,2.77a31.72,31.72,0,0,1,5.89,2.87c3.72,2.12,7.86,4.93,8.1,9.18a3.49,3.49,0,0,0,.4,2,2.91,2.91,0,0,0,1.78.9,52.92,52.92,0,0,0,9.71,1.35"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '78.53499984741211px 260.3517780303955px',
          }}
          id="elcyqvo0xq8gk"
          className="animable"
        />
        <path
          d="M91.37,279.58c.06,3.8.33,7.78.27,11.55-.09,5.47-1.9,10.89-1.3,16.3.88,7.66,6.26,13.94,11,20.1,17.84,23.57,27.66,51.83,38.1,79.53h0c1.93,1.53,3.9,3,5.89,4.37,1.58,1.12,3.16,2.22,4.77,3.29s3.23,2.12,4.88,3.14c1.15.72,2.3,1.4,3.48,2.09-.15-.33-.31-.63-.46-.95-4.2-9.13-4.44-22.29,4.6-26.8,1.72-.87,3.69-1.35,5.11-2.67,4-3.76.72-11.54,4.75-15.31,2.26-2.09,5.8-1.94,8.61-3.2,5-2.3,6.69-8.7,6.29-14.21s-2.23-10.92-1.6-16.39c1-8.28,7.53-16.69,3.78-24.17-4.2-8.34-16.45-7-25.07-10.73-12-5.24-15.75-20-23.61-30.45-7.05-9.34-23.5-19.59-36-16.78-9.07,2-12.19,7.39-13.13,14"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '140.45452117919922px 338.88370513916016px',
          }}
          id="elbbd9jna12ed"
          className="animable"
        />
        <path
          d="M77.34,202.69c3.56-3,9.73-3.38,12.48.39,2,2.69,1.52,6.37,1,9.66q-1,6.63-2.11,13.28a6.74,6.74,0,0,0,.18,4c1.33,2.81,6,2.27,7.77-.24s1.6-6,1.12-9-1.12-6.31.09-9.18c3-7.12,13.76-6,20-10.68,3.87-2.87,5.6-7.68,7.9-11.9s6.13-8.44,11-8.23c1.63.06,3.24.66,4.87.6,4.78-.15,7.56-7.06,4.17-10.41a11.91,11.91,0,0,1-2.11-2.15c-.85-1.59.06-3.62,1.51-4.7a11.47,11.47,0,0,1,5.08-1.61c4.08-.66,8.16-1.29,12.24-1.92,4.51-.68,10.28-3,9.65-7.44-.54-3.86-5.84-5.6-6.62-9.43a12.12,12.12,0,0,0-.52-2.81c-1.24-2.45-5-1.46-7.34-.15-1-3.56-6.11-5.17-9-2.84-2.41,2-2.72,5.45-3.56,8.41-2,7.17-7.77,12.62-13.28,17.67-1.84,1.68-3.93,3.47-6.44,3.59s-5.14-2.54-4-4.72c.79-1.5,3-2.37,2.75-4-.3-2.1-4-1.95-4.71-3.95,1.45-5.92,8.31-8.37,13.57-11.55a32.57,32.57,0,0,0,13.88-16.86,4.23,4.23,0,0,0,.18-3.47c-.78-1.5-2.81-1.74-4.53-1.74-4.05-.06-9.1.48-10.59,4.22-.78,2-.21,4.28-.69,6.37-1.42,6.22-10,6.91-15.3,10.62-2.06,1.43-3.66,3.44-5.93,4.54-2.45,1.17-5.32,1.08-8,1.29-.48,0-1,.09-1.45.15-1.66,2.29-3.27,4.62-4.81,7s-3,4.78-4.47,7.22a185.35,185.35,0,0,0-16.57,36.55c-1.49,4.47-2.79,9-3.93,13.63s-2.09,9.29-2.88,14c1.88-3.82,2.72-8.55,3.45-11.9C72.32,210.43,73.8,205.71,77.34,202.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '120.0837173461914px 176.60574340820312px',
          }}
          id="ellw7n5jg3dyi"
          className="animable"
        />
        <path
          d="M447.34,255.14q0-4.08-.25-8.1c-.14-2.69-.36-5.36-.63-8-.21-2.15-.45-4.28-.75-6.4s-.64-4.48-1-6.69a180.28,180.28,0,0,0-4.47-19.63c-.71-2.47-1.27-4.92-2.08-7.35s-1.85-4.82-2.76-7.22v0h0c-1-1.79-2-3.56-3.11-5.29-10.61-16.63-26-29.67-37.71-45.58-3.8-5.18-6.77-9.46-13.51-10.47-10-1.53-15,4.09-22.1-5.27-1.91-2.51-5.23-4.84-8-3.35.73,2,1.48,4,2.21,6a2.87,2.87,0,0,1,.24,1.32c-.15,1.41-2.27,1.8-3.48,1s-1.81-2.22-2.66-3.38c-3.14-4.46-10.52-5-14.36-1.17a5.46,5.46,0,0,0-3.17-4.43,6.57,6.57,0,0,1-8.23,5.24c-.57-1.83,2.72-2.16,3.87-3.71s-.21-3.5-1.57-4.73a21.14,21.14,0,0,0-13.15-5c-3.06-.06-6.35.51-9-1-1.55-.9-2.63-2.39-4.21-3.26-3.35-1.88-7.56-.15-10.94,1.71-4.63,2.54-9.41,5.74-11,10.73s2,11.7,7.26,11.07c1.33-.18,2.72-.81,4-.45,1.87.51,2.72,2.66,2.87,4.58s-.06,3.92.88,5.59,3.66,2.51,4.72.93c2.48-2.33,2.17-6.25,1.54-9.57s-1.3-7.06.69-9.78,7.77-1.86,7.38,1.49c-.24,2-2.51,3.41-2.42,5.42s2.6,3.11,4.66,3,4.14-.81,6.14-.3,3.63,3.08,2.17,4.55c-2.51,2.81-9-2-10.34,1.49-.36.9,0,1.91-.09,2.87-.24,2.93-4,4-6.92,4.37s-6.11.63-8.8-.63-4.54-4.76-3-7.27c-1.52-1.07-3.81,0-4.63,1.68s-.58,3.62-.33,5.44c-3.15-.69-6,1.94-7.74,4.55s-3.54,5.68-6.6,6.61-7.31-.33-8.92,2.42c-2.08,3.59,4,8.14,1.85,11.69-1.21,2-4.11,2-6.41,2.58-6.08,1.7-8.2,10.5-4.05,15.19s12.42,4.43,16.81-.06c3-3.08,4.29-7.42,6.5-11.12s6.38-7,10.55-5.84a12.73,12.73,0,0,1,4.33,2.7c2,1.67,4,3.34,6.07,5,1.3,1.08,2.73,2.42,2.6,4.1-.12,1.34-1.18,2.39-1.63,3.65-1.27,3.62,4,7.05,7.35,5.08s3.69-7,1.42-10.14c-3.14-4.31-10.25-6.46-10.07-11.78,3.63-2.93,9.34.15,11.46,4.3s2.18,9,4,13.31,6.78,8.11,10.95,6c-1.09-3.71-2.15-7.39-3.24-11.07,2.66-2,5.72,3.77,8.89,2.81,1.94-.6,2.18-3.35,1.33-5.2S324.3,177,323.94,175c-.6-3.65,3.51-6.91,7.23-6.31s6.38,4.1,7.07,7.72a17.62,17.62,0,0,0,1,4.28c1.39,2.87,5,3.73,8,4.93s6.08,4.16,4.84,7.09c-.57,1.29-1.93,2.51-1.45,3.83.45,1.17,2.21,1.67,2.21,2.93,0,.84-.91,1.41-1.7,1.73-2,.81-4.17,1.08-6.1,2s-3.69,2.75-3.54,4.84c.24,3,3.84,4.43,5.53,6.91s1.39,5.51,2.42,8.2c1,2.48,3,4.42,4.57,6.55,5,6.76,6.2,15.46,8.64,23.48,1.09,3.62,3.09,7.66,6.84,8.34,2.05.36,4.11-.42,6.05-1.16,5.41-2.13,11-4.4,14.81-8.74s5.08-11.45,1.18-15.73a3.07,3.07,0,0,0-1.84-1.17c-1-.12-1.94.57-2.85,1-2.75,1.26-6.13.21-8.43-1.79s-3.66-4.76-5-7.45c-1.48-3-3-6-4.48-8.94,1.79-1.5,4.63-.87,6.47.59s2.94,3.59,4.42,5.39c4.5,5.56,11.91,8,19.08,8.85a18.29,18.29,0,0,1,5.38,1.11c5.35,2.42,6.89,10.23,12.55,11.9,1.57.48,3.32.39,4.81,1.08,2.23,1,3.35,3.56,4,5.92,1.24,4.4,1.66,9,3.53,13.22s5.63,8,10.23,8.05a11.08,11.08,0,0,0,7.68-3.38v0c.24-4.13.39-8.26.39-12.45C447.4,256.88,447.4,256,447.34,255.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '347.3787078857422px 190.75424194335938px',
          }}
          id="elknbu26f4zm"
          className="animable"
        />
        <path
          d="M48.36,273.8a35.3,35.3,0,0,1-.44-6,34.38,34.38,0,0,1,.09-6,34.87,34.87,0,0,1,.43,6A35.22,35.22,0,0,1,48.36,273.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '48.18056482076645px 267.79998779296875px',
          }}
          id="ellfgi0cd32ro"
          className="animable"
        />
        <path
          d="M51.2,297.6a35.17,35.17,0,0,1-1.14-5.89,33.91,33.91,0,0,1-.63-6,35.45,35.45,0,0,1,1.14,5.89A33.76,33.76,0,0,1,51.2,297.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '50.31500053405762px 291.6549987792969px',
          }}
          id="eleujrqaqfptl"
          className="animable"
        />
        <path
          d="M56.88,320.88A35.58,35.58,0,0,1,55,315.17a33.85,33.85,0,0,1-1.35-5.85A35.08,35.08,0,0,1,55.54,315,34.33,34.33,0,0,1,56.88,320.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '55.265005111694336px 315.1000061035156px',
          }}
          id="eljuxl8om0zt"
          className="animable"
        />
        <path
          d="M65.32,343.31a34.79,34.79,0,0,1-2.52-5.44,35.46,35.46,0,0,1-2-5.65,34.67,34.67,0,0,1,2.52,5.45A34.8,34.8,0,0,1,65.32,343.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '63.05999946594238px 337.76499938964844px',
          }}
          id="elvg39dz6xxke"
          className="animable"
        />
        <path
          d="M76.36,364.57a34.42,34.42,0,0,1-3.14-5.1,36,36,0,0,1-2.7-5.36,34.07,34.07,0,0,1,3.15,5.11A34,34,0,0,1,76.36,364.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '73.44000625610352px 359.3400115966797px',
          }}
          id="elcfjdmfuziec"
          className="animable"
        />
        <path
          d="M89.84,384.39a35,35,0,0,1-3.72-4.7,34.59,34.59,0,0,1-3.31-5,35.22,35.22,0,0,1,3.73,4.7A33.77,33.77,0,0,1,89.84,384.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '86.32500076293945px 379.5400085449219px',
          }}
          id="elaarffic09w8"
          className="animable"
        />
        <path
          d="M105.55,402.5a34,34,0,0,1-4.25-4.24,33.74,33.74,0,0,1-3.87-4.59,35.79,35.79,0,0,1,4.25,4.24A34.86,34.86,0,0,1,105.55,402.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '101.4900016784668px 398.0850067138672px',
          }}
          id="ela5ioo1s4w2p"
          className="animable"
        />
        <path
          d="M123.23,418.67a34.77,34.77,0,0,1-4.7-3.72,33,33,0,0,1-4.37-4.11,35.45,35.45,0,0,1,4.71,3.72A35,35,0,0,1,123.23,418.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '118.69501876831055px 414.7550506591797px',
          }}
          id="el80ay35t9fn3"
          className="animable"
        />
        <path
          d="M142.66,432.7a34.26,34.26,0,0,1-5.1-3.15,34.79,34.79,0,0,1-4.81-3.58,34.12,34.12,0,0,1,5.1,3.15A34.61,34.61,0,0,1,142.66,432.7Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '137.7050018310547px 429.33502197265625px',
          }}
          id="eltx26o5re63c"
          className="animable"
        />
        <path
          d="M163.57,444.42a34.64,34.64,0,0,1-5.43-2.55,34.32,34.32,0,0,1-5.19-3,36,36,0,0,1,5.43,2.55A34,34,0,0,1,163.57,444.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '158.26000213623047px 441.64501953125px',
          }}
          id="els5w8h1mmzq7"
          className="animable"
        />
        <path
          d="M185.68,453.67a34.43,34.43,0,0,1-5.68-1.91,34.07,34.07,0,0,1-5.5-2.4,34.89,34.89,0,0,1,5.68,1.91A34,34,0,0,1,185.68,453.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '180.08999633789062px 451.5150146484375px',
          }}
          id="el21qsz5j5yqp"
          className="animable"
        />
        <path
          d="M208.7,460.34a34.61,34.61,0,0,1-5.86-1.25,35.2,35.2,0,0,1-5.74-1.76,34.4,34.4,0,0,1,5.87,1.25A33.8,33.8,0,0,1,208.7,460.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '202.9000015258789px 458.8349914550781px',
          }}
          id="el4hliju3r2a2"
          className="animable"
        />
        <path
          d="M232.33,464.34a33.51,33.51,0,0,1-6-.57,33.89,33.89,0,0,1-5.9-1.1,35.28,35.28,0,0,1,6,.58A35.56,35.56,0,0,1,232.33,464.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '226.37999725341797px 463.5050048828125px',
          }}
          id="elnwbt44xcqie"
          className="animable"
        />
        <path
          d="M256.26,465.68a35.61,35.61,0,0,1-6,.09,33.71,33.71,0,0,1-6-.43,35.89,35.89,0,0,1,6-.09A33.65,33.65,0,0,1,256.26,465.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.260009765625px 465.5104642212391px',
          }}
          id="eles899mqleah"
          className="animable"
        />
        <path
          d="M280.2,464.34a33,33,0,0,1-5.95.76,33.53,33.53,0,0,1-6,.24,35.78,35.78,0,0,1,6-.76A35.8,35.8,0,0,1,280.2,464.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '274.2250061035156px 464.8441607952118px',
          }}
          id="eln32h1xy1gv"
          className="animable"
        />
        <path
          d="M303.84,460.33a34.9,34.9,0,0,1-5.83,1.43,34.24,34.24,0,0,1-5.93.91,34.35,34.35,0,0,1,5.83-1.42A34.49,34.49,0,0,1,303.84,460.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '297.9600067138672px 461.49998474121094px',
          }}
          id="elfiruc8776p9"
          className="animable"
        />
        <path
          d="M326.86,453.66a33.65,33.65,0,0,1-5.63,2.08,35,35,0,0,1-5.79,1.59,35.46,35.46,0,0,1,5.63-2.08A35.94,35.94,0,0,1,326.86,453.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '321.1499786376953px 455.4949951171875px',
          }}
          id="ely1jpqsgk7b9"
          className="animable"
        />
        <path
          d="M349,444.41a34.29,34.29,0,0,1-5.35,2.71,33.42,33.42,0,0,1-5.57,2.23A70.57,70.57,0,0,1,349,444.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '343.5399932861328px 446.87998962402344px',
          }}
          id="elywhimtlvic"
          className="animable"
        />
        <path
          d="M369.88,432.69a34.57,34.57,0,0,1-5,3.31,33.85,33.85,0,0,1-5.28,2.85,36.22,36.22,0,0,1,5-3.3A35,35,0,0,1,369.88,432.69Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '364.7400207519531px 435.77000427246094px',
          }}
          id="ele03883awhk"
          className="animable"
        />
        <path
          d="M389.31,418.66a35.43,35.43,0,0,1-4.6,3.85A34.34,34.34,0,0,1,379.8,426a34.8,34.8,0,0,1,4.59-3.85A35.45,35.45,0,0,1,389.31,418.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '384.55499267578125px 422.3299865722656px',
          }}
          id="ele6be21y83w9"
          className="animable"
        />
        <path
          d="M407,402.49a33.68,33.68,0,0,1-4.12,4.35,34.85,34.85,0,0,1-4.49,4,69.68,69.68,0,0,1,8.61-8.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '402.6950225830078px 406.6649932861328px',
          }}
          id="elx91ivc0cnuc"
          className="animable"
        />
        <path
          d="M422.69,384.39a36.75,36.75,0,0,1-3.59,4.8,33.46,33.46,0,0,1-4,4.47,35.27,35.27,0,0,1,3.59-4.8A33.4,33.4,0,0,1,422.69,384.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '418.89503479003906px 389.02500915527344px',
          }}
          id="el878p2q2r0b3"
          className="animable"
        />
        <path
          d="M436.17,364.57a70.94,70.94,0,0,1-6.45,10.11,67.29,67.29,0,0,1,6.45-10.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '432.94500732421875px 369.625px',
          }}
          id="elwhpq9nf485"
          className="animable"
        />
        <path
          d="M447.22,343.3a34.56,34.56,0,0,1-2.37,5.51A34,34,0,0,1,442,354.1a33.72,33.72,0,0,1,2.37-5.51A33.22,33.22,0,0,1,447.22,343.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '444.61000061035156px 348.6999969482422px',
          }}
          id="elayf72ulfce"
          className="animable"
        />
        <path
          d="M455.65,320.87a34.64,34.64,0,0,1-1.69,5.75,35.73,35.73,0,0,1-2.19,5.59,67.72,67.72,0,0,1,3.88-11.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '453.7099914550781px 326.5399932861328px',
          }}
          id="elpp7qmuxbez"
          className="animable"
        />
        <path
          d="M461.32,297.59a34,34,0,0,1-1,5.91,34.34,34.34,0,0,1-1.5,5.81,70.49,70.49,0,0,1,2.48-11.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '460.07000732421875px 303.4499969482422px',
          }}
          id="el5boyocnq2i2"
          className="animable"
        />
        <path
          d="M464.17,273.79a34.83,34.83,0,0,1-.28,6,34.41,34.41,0,0,1-.79,6,35.35,35.35,0,0,1,.27-6A34.38,34.38,0,0,1,464.17,273.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '463.63452208042145px 279.7899932861328px',
          }}
          id="eljlr9av93tnp"
          className="animable"
        />
        <path
          d="M464.17,249.82a34.61,34.61,0,0,1,.43,6,35.1,35.1,0,0,1-.08,6,35.43,35.43,0,0,1-.44-6A34.56,34.56,0,0,1,464.17,249.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '464.3411374986172px 255.82000732421875px',
          }}
          id="el8q1o0naxu5i"
          className="animable"
        />
        <path
          d="M461.32,226a34.54,34.54,0,0,1,1.15,5.89,35.1,35.1,0,0,1,.63,6A34.81,34.81,0,0,1,462,232,34.93,34.93,0,0,1,461.32,226Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '462.2099914550781px 231.94499969482422px',
          }}
          id="el4om7csxgosd"
          className="animable"
        />
        <path
          d="M455.64,202.74a33.47,33.47,0,0,1,1.85,5.71,34.57,34.57,0,0,1,1.34,5.84,34.84,34.84,0,0,1-1.84-5.71A36,36,0,0,1,455.64,202.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '457.2350311279297px 208.51500701904297px',
          }}
          id="elhalitbhlwcv"
          className="animable"
        />
        <path
          d="M447.21,180.3a35.2,35.2,0,0,1,2.52,5.45,33.75,33.75,0,0,1,2,5.64,34.8,34.8,0,0,1-2.51-5.44A34.71,34.71,0,0,1,447.21,180.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '449.46998596191406px 185.8449935913086px',
          }}
          id="elcvbs6lu8p0m"
          className="animable"
        />
        <path
          d="M436.16,159a34.07,34.07,0,0,1,3.15,5.11,33.3,33.3,0,0,1,2.69,5.36,36.28,36.28,0,0,1-3.14-5.11A35.08,35.08,0,0,1,436.16,159Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '439.0799865722656px 164.23500061035156px',
          }}
          id="elfsca5un2bao"
          className="animable"
        />
        <path
          d="M422.68,139.23a33,33,0,0,1,3.73,4.7,35.64,35.64,0,0,1,3.31,5,35,35,0,0,1-3.73-4.71A35,35,0,0,1,422.68,139.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '426.1999816894531px 144.07999420166016px',
          }}
          id="elp6l021vj02"
          className="animable"
        />
        <path
          d="M407,121.12a34.81,34.81,0,0,1,4.25,4.24A35.62,35.62,0,0,1,415.1,130a34.94,34.94,0,0,1-4.25-4.24A34.86,34.86,0,0,1,407,121.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '411.0500030517578px 125.55999755859375px',
          }}
          id="el8us4d8qlf5l"
          className="animable"
        />
        <path
          d="M389.29,105a34.47,34.47,0,0,1,4.71,3.72,33.82,33.82,0,0,1,4.37,4.11,35,35,0,0,1-4.71-3.72A35.52,35.52,0,0,1,389.29,105Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '393.83001708984375px 108.91500091552734px',
          }}
          id="elftlm7nj2aud"
          className="animable"
        />
        <path
          d="M369.86,90.91A34.66,34.66,0,0,1,375,94.07a35.57,35.57,0,0,1,4.81,3.58,33.91,33.91,0,0,1-5.11-3.15A34.73,34.73,0,0,1,369.86,90.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.8349914550781px 94.28001022338867px',
          }}
          id="elah7in4uhuto"
          className="animable"
        />
        <path
          d="M349,79.2a34,34,0,0,1,5.44,2.55,34,34,0,0,1,5.19,3,35.78,35.78,0,0,1-5.44-2.55A35.22,35.22,0,0,1,349,79.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '354.31500244140625px 81.9749870300293px',
          }}
          id="elafd4lyby2wf"
          className="animable"
        />
        <path
          d="M326.84,70a34,34,0,0,1,5.69,1.91,33.54,33.54,0,0,1,5.5,2.4,36,36,0,0,1-5.69-1.91A36.2,36.2,0,0,1,326.84,70Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '332.4349822998047px 72.15499877929688px',
          }}
          id="elsl49trmxs1"
          className="animable"
        />
        <path
          d="M303.82,63.28a34.61,34.61,0,0,1,5.87,1.25,34.07,34.07,0,0,1,5.74,1.76A35.6,35.6,0,0,1,309.56,65,34.84,34.84,0,0,1,303.82,63.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '309.625px 64.78499603271484px',
          }}
          id="eln9kh2hvpey"
          className="animable"
        />
        <path
          d="M280.2,59.27a35.43,35.43,0,0,1,6,.58,35,35,0,0,1,5.9,1.09,33.38,33.38,0,0,1-6-.57A33.28,33.28,0,0,1,280.2,59.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '286.15000915527344px 60.105003356933594px',
          }}
          id="el8rufrbtmfaw"
          className="animable"
        />
        <path
          d="M256.26,57.94a35.67,35.67,0,0,1,6-.09,35.27,35.27,0,0,1,6,.42,33.87,33.87,0,0,1-6,.1A33.71,33.71,0,0,1,256.26,57.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '262.260009765625px 58.11121815443039px',
          }}
          id="eluubiwdvqlwp"
          className="animable"
        />
        <path
          d="M232.32,59.27a35,35,0,0,1,6-.75,35.25,35.25,0,0,1,6-.25,33.22,33.22,0,0,1-6,.76A33.52,33.52,0,0,1,232.32,59.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.31999969482422px 58.773920118808746px',
          }}
          id="el02l6xhr3adhm"
          className="animable"
        />
        <path
          d="M208.69,63.29a34.9,34.9,0,0,1,5.83-1.43,33.12,33.12,0,0,1,5.93-.91,35,35,0,0,1-5.83,1.42A34.63,34.63,0,0,1,208.69,63.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '214.57000732421875px 62.119998931884766px',
          }}
          id="elkpprwwxha1r"
          className="animable"
        />
        <path
          d="M185.67,70a35.42,35.42,0,0,1,5.62-2.07,34.13,34.13,0,0,1,5.79-1.59,34.54,34.54,0,0,1-5.63,2.08A34.11,34.11,0,0,1,185.67,70Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '191.37499237060547px 68.17000198364258px',
          }}
          id="elavvs788ysvk"
          className="animable"
        />
        <path
          d="M163.55,79.21a35.3,35.3,0,0,1,5.36-2.71,34.77,34.77,0,0,1,5.57-2.24A33.79,33.79,0,0,1,169.12,77,34,34,0,0,1,163.55,79.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '169.01500701904297px 76.73501205444336px',
          }}
          id="elvar025aqn2k"
          className="animable"
        />
        <path
          d="M142.65,90.93a34.57,34.57,0,0,1,5-3.31,34,34,0,0,1,5.27-2.85,35.47,35.47,0,0,1-5,3.3A35.21,35.21,0,0,1,142.65,90.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '147.78499603271484px 87.85000228881836px',
          }}
          id="el72274hgpblq"
          className="animable"
        />
        <path
          d="M123.22,105a34.52,34.52,0,0,1,4.6-3.85,36,36,0,0,1,4.91-3.45,34,34,0,0,1-4.6,3.86A35.05,35.05,0,0,1,123.22,105Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.97499465942383px 101.35000610351562px',
          }}
          id="elm6xjzt3i3qh"
          className="animable"
        />
        <path
          d="M105.53,121.13a35.59,35.59,0,0,1,4.13-4.36,35.38,35.38,0,0,1,4.48-4,34.31,34.31,0,0,1-4.12,4.36A33.69,33.69,0,0,1,105.53,121.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '109.83499908447266px 116.94999694824219px',
          }}
          id="eldqm74tyhyxu"
          className="animable"
        />
        <path
          d="M89.84,139.23a35,35,0,0,1,3.59-4.8,36.12,36.12,0,0,1,4-4.48,34.3,34.3,0,0,1-3.59,4.81A34.61,34.61,0,0,1,89.84,139.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '93.63499069213867px 134.58999633789062px',
          }}
          id="elukta79e23xl"
          className="animable"
        />
        <path
          d="M76.36,159.05a34,34,0,0,1,3-5.19,34.93,34.93,0,0,1,3.45-4.92,34.93,34.93,0,0,1-3,5.2A36.17,36.17,0,0,1,76.36,159.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '79.58499908447266px 153.99501037597656px',
          }}
          id="elb8cana337fn"
          className="animable"
        />
        <path
          d="M65.31,180.32a34.56,34.56,0,0,1,2.37-5.51,34,34,0,0,1,2.84-5.29A35.25,35.25,0,0,1,68.15,175,35.24,35.24,0,0,1,65.31,180.32Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '67.91500473022461px 174.9200210571289px',
          }}
          id="elicriftqo6pq"
          className="animable"
        />
        <path
          d="M56.88,202.75A34.35,34.35,0,0,1,58.57,197a33.54,33.54,0,0,1,2.19-5.59,35.87,35.87,0,0,1-1.7,5.76A35.13,35.13,0,0,1,56.88,202.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '58.82000160217285px 197.07999420166016px',
          }}
          id="elq7rvjzeakjr"
          className="animable"
        />
        <path
          d="M51.2,226a34.84,34.84,0,0,1,1-5.92,34.38,34.38,0,0,1,1.5-5.8,34.35,34.35,0,0,1-1,5.91A33.88,33.88,0,0,1,51.2,226Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '52.45000076293945px 220.13999938964844px',
          }}
          id="el2b3su1li72d"
          className="animable"
        />
        <path
          d="M48.36,249.83a35.5,35.5,0,0,1,.27-6,33.76,33.76,0,0,1,.8-5.94,34.81,34.81,0,0,1-.28,6A35.21,35.21,0,0,1,48.36,249.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '48.89474940299988px 243.86000061035156px',
          }}
          id="el8y1zldftg74"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-3--inject-103"
        style={{ transformOrigin: '356.67999267578125px 248.4748764038086px' }}
        className="animable"
      >
        <path
          d="M279.14,262.37s0-.42.05-1.24.05-2.05.23-3.64A74.91,74.91,0,0,1,282,243.72a77,77,0,0,1,3.42-9.54A73.39,73.39,0,0,1,291,223.53a77.45,77.45,0,0,1,20.13-21.21A75.52,75.52,0,0,1,326.06,194a74.36,74.36,0,0,1,17.82-5,77.63,77.63,0,0,1,30.05,1.27,80,80,0,0,1,10.17,3.25,76.91,76.91,0,0,1,34.84,27.87,75.58,75.58,0,0,1,5.94,10.27c.89,1.79,1.64,3.65,2.41,5.51s1.39,3.79,1.94,5.74a77.5,77.5,0,0,1,3.16,24.35,82.8,82.8,0,0,1-1.4,12.33,74.43,74.43,0,0,1-3.3,11.78c-.68,1.92-1.5,3.76-2.3,5.61s-1.75,3.62-2.75,5.35a75.68,75.68,0,0,1-6.59,9.87,76.92,76.92,0,0,1-36.55,25.61,80.87,80.87,0,0,1-10.36,2.59,78,78,0,0,1-30.08-.64,76.57,76.57,0,0,1-31.81-15.41,77.24,77.24,0,0,1-18.73-22.45,72.94,72.94,0,0,1-5-11,74.6,74.6,0,0,1-2.8-9.73,75.67,75.67,0,0,1-1.65-13.91c-.08-1.6,0-2.82,0-3.64s0-1.24,0-1.24,0,.42,0,1.24,0,2,0,3.64A77.11,77.11,0,0,0,281,281.12a75,75,0,0,0,2.83,9.69,73.63,73.63,0,0,0,5,10.93A77.35,77.35,0,0,0,307.48,324a74.92,74.92,0,0,0,14.31,9.18,74.15,74.15,0,0,0,17.37,6.09,77.72,77.72,0,0,0,29.9.61,81.07,81.07,0,0,0,10.29-2.58,76.55,76.55,0,0,0,42.84-35.28c1-1.72,1.85-3.52,2.73-5.32s1.61-3.66,2.28-5.56a74.92,74.92,0,0,0,3.28-11.71,83.08,83.08,0,0,0,1.39-12.24A77,77,0,0,0,428.73,243c-.54-1.94-1.25-3.82-1.92-5.7s-1.51-3.7-2.39-5.47a74.08,74.08,0,0,0-5.9-10.21,76.46,76.46,0,0,0-34.6-27.72,80.53,80.53,0,0,0-10.1-3.23A75.71,75.71,0,0,0,363.65,189a76.51,76.51,0,0,0-19.71.45,76.35,76.35,0,0,0-32.58,13.22,77.38,77.38,0,0,0-20.1,21.07,74.49,74.49,0,0,0-5.66,10.59,75.38,75.38,0,0,0-3.45,9.49,77.38,77.38,0,0,0-2.63,13.73c-.19,1.59-.2,2.81-.28,3.63S279.14,262.37,279.14,262.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '355.729736328125px 264.8291244506836px',
          }}
          id="el2ik85uf5toe"
          className="animable"
        />
        <g id="el9qiu9pve1y4">
          <circle
            cx="356.68"
            cy="266.13"
            r="63.16"
            style={{
              fill: 'rgb(250, 250, 250)',
              transformOrigin: '356.67999999999995px 266.13px',
              transform: 'rotate(-45deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M293.56,264.11s0-1.39.22-4a61.89,61.89,0,0,1,2.08-11.37,63.15,63.15,0,0,1,7.48-16.67A64.09,64.09,0,0,1,320,214.53a63.35,63.35,0,0,1,27-11,63.17,63.17,0,0,1,16.36-.4,62.49,62.49,0,0,1,8.45,1.45,65.47,65.47,0,0,1,8.4,2.68,63.45,63.45,0,0,1,28.78,23,60.15,60.15,0,0,1,4.9,8.48,58.17,58.17,0,0,1,3.59,9.29,63.35,63.35,0,0,1-1.27,40A59,59,0,0,1,412,297.1a63.6,63.6,0,0,1-35.63,29.3,67.59,67.59,0,0,1-8.55,2.13,62.41,62.41,0,0,1-8.53.91A63.36,63.36,0,0,1,343,328a63.29,63.29,0,0,1-26.27-12.73,63.21,63.21,0,0,1-21.86-35.65,61.55,61.55,0,0,1-1.35-11.47c0-2.65,0-4,0-4s0,.35,0,1,0,1.68,0,3A63.2,63.2,0,0,0,317,315a63.06,63.06,0,0,0,26.12,12.59,63,63,0,0,0,16.2,1.4,61.55,61.55,0,0,0,8.47-.91,66.58,66.58,0,0,0,8.48-2.13A63,63,0,0,0,417,248.17a59.89,59.89,0,0,0-3.56-9.21A63,63,0,0,0,380,207.68a68.39,68.39,0,0,0-8.34-2.67A64,64,0,0,0,347,203.93a63.15,63.15,0,0,0-26.88,10.9,64,64,0,0,0-16.58,17.38,63.1,63.1,0,0,0-9.7,27.89c-.16,1.31-.17,2.32-.24,3S293.56,264.11,293.56,264.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '356.8192596435547px 266.1364936828613px',
          }}
          id="el012v80kze5sw"
          className="animable"
        />
        <path
          d="M336.05,164.45a7.41,7.41,0,0,0-4.68-6,6.93,6.93,0,0,0-7.31,1.76,6.53,6.53,0,0,0-.86,7.42,7.48,7.48,0,0,0,5.43,3.46,12.36,12.36,0,0,0,6.5-1"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '329.2353820800781px 164.61681365966797px',
          }}
          id="el8d44hb4xdzr"
          className="animable"
        />
        <path
          d="M350.36,176.31a32.25,32.25,0,0,1,3.13,15.6c-.44,5.34-2.89,10.66-7.24,13.79a4,4,0,0,1-2.84,1c-1-.16-1.89-1.33-1.39-2.23a13.18,13.18,0,0,1-3.65,3.9,2.44,2.44,0,0,1-1.64.59,1.82,1.82,0,0,1-1.36-1.91,5.26,5.26,0,0,1,.9-2.38c-1-.09-2,.61-2.9,1.07s-2.31.56-2.83-.35.08-1.81.61-2.58c2.4-3.52,4.84-7.24,5.36-11.48.36-3-.27-6.13.45-9.08a10.37,10.37,0,0,1,7.47-7.45c2.08-.49,4.55-.18,5.86,1.49"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '341.93634605407715px 191.7746410369873px',
          }}
          id="el0ijhmkbsvtr9"
          className="animable"
        />
        <path
          d="M372.17,200.78c2.14-2.73,6.09-3.53,7.82-6.54,3.05-5.29,2.83-10.28,2.82-16.4,0-4.18.59-10.1-1.87-13.48-1.73-2.39-3-3.85-4.5-6.36-1.69-2.76-3.43-6-1.62-8.71"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.52102184295654px 175.03500366210938px',
          }}
          id="elpy3nscvx3gb"
          className="animable"
        />
        <path
          d="M371.34,200.82a6,6,0,0,1,7.16-.94l-3.66-51.25c2.33-.24,7.66,3.05,9.14,4.86a21.5,21.5,0,0,1,3.15,6.23c3.35,9,.48,19.62-3.81,27.55h0c2.48,6.9,2.37,13.28-1.84,17.2l-.07.06-.6.57A5.78,5.78,0,0,0,379,210v.07a5.83,5.83,0,0,1,.08,1.61,1.55,1.55,0,0,1-.91,1.24c-.82.28-1.65-.48-2-1.29a9.58,9.58,0,0,0-1-2.41,26.17,26.17,0,0,0-1.41,2.86c-.56.91-1.83,1.59-2.68.95a2.49,2.49,0,0,1-.7-1.13,15.67,15.67,0,0,1-1.21-5.75A7.66,7.66,0,0,1,371.34,200.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '378.8828077316284px 180.94939804077148px',
          }}
          id="ell32mym9w6n8"
          className="animable"
        />
        <path
          d="M344.67,169.77l.23,44.41a13.21,13.21,0,0,0,13.93,13.12h0a12.8,12.8,0,0,0,12.08-13.2c0-3.34.17-7.29.19-7.63,0,0,11.19-2.14,11.95-13.34.37-5.41.53-14.51.27-24.64a20.89,20.89,0,0,0-19.74-20.33l-1.08-.06C350.81,148.13,344.31,158.08,344.67,169.77Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '364.05182456970215px 187.7098388671875px',
          }}
          id="elyo51vrnyjlj"
          className="animable"
        />
        <path
          d="M371.15,206.53a26.15,26.15,0,0,1-14.38-5s3,8.25,14.24,7.86Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '363.95997619628906px 205.4667010307312px',
          }}
          id="elom25l4z0dsk"
          className="animable"
        />
        <path
          d="M377.3,176.93a1.59,1.59,0,0,1-1.63,1.53,1.54,1.54,0,0,1-1.57-1.53,1.61,1.61,0,0,1,1.63-1.53A1.53,1.53,0,0,1,377.3,176.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.69996643066406px 176.93000650405884px',
          }}
          id="el59cd4jimk6u"
          className="animable"
        />
        <path
          d="M380.18,173.42c-.18.15-1.43-.12-3.13.18s-2.88,1-3.08.9.08-.27.6-.58a7.5,7.5,0,0,1,2.45-.87,6.63,6.63,0,0,1,2.51,0C380.07,173.18,380.27,173.36,380.18,173.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.0529565811157px 173.71989464759827px',
          }}
          id="eljv24v0phsba"
          className="animable"
        />
        <path
          d="M360,175.79a1.61,1.61,0,0,1-1.63,1.53,1.53,1.53,0,0,1-1.57-1.53,1.59,1.59,0,0,1,1.63-1.53A1.54,1.54,0,0,1,360,175.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '358.40000915527344px 175.7899922132492px',
          }}
          id="el3m84f62xyls"
          className="animable"
        />
        <path
          d="M363.45,174.5c-.23,0-1.17-.83-2.78-1.43s-3-.62-3.12-.79.21-.2.81-.2a7.29,7.29,0,0,1,2.55.5,6.66,6.66,0,0,1,2.16,1.27C363.48,174.24,363.56,174.49,363.45,174.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '360.51019763946533px 173.29000854492188px',
          }}
          id="eljwv5v8erg6g"
          className="animable"
        />
        <path
          d="M369.22,186.35A10.81,10.81,0,0,1,372,186c.44,0,.86-.09.95-.38a2.2,2.2,0,0,0-.22-1.32q-.52-1.63-1.11-3.42C370.12,176,369,172,369.22,172s1.61,3.83,3.15,8.7l1.06,3.44a2.52,2.52,0,0,1,.13,1.73,1.1,1.1,0,0,1-.76.61,2.9,2.9,0,0,1-.75.06A11.6,11.6,0,0,1,369.22,186.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.42401003837585px 179.27894067764282px',
          }}
          id="elq3zfalqph2"
          className="animable"
        />
        <path
          d="M364.08,187.26c.28,0,.19,1.86,1.71,3.28s3.53,1.32,3.53,1.58-.47.34-1.31.31a4.61,4.61,0,0,1-2.95-1.21,4.07,4.07,0,0,1-1.31-2.75C363.72,187.69,364,187.24,364.08,187.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '366.5338625907898px 189.84765672683716px',
          }}
          id="el8zxjhhfry6o"
          className="animable"
        />
        <path
          d="M363.65,167.72c-.19.46-1.9.14-3.93.27s-3.7.6-3.94.16c-.11-.21.2-.63.88-1.05a6.92,6.92,0,0,1,6-.33C363.38,167.11,363.74,167.5,363.65,167.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '359.71092104911804px 167.28671848773956px',
          }}
          id="el4lrhq0mv0fh"
          className="animable"
        />
        <path
          d="M380.26,168.83c-.33.38-1.49-.09-2.92-.19s-2.64.12-2.9-.31c-.11-.2.1-.59.65-.93a4.22,4.22,0,0,1,4.69.41C380.26,168.24,380.4,168.65,380.26,168.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.3616690635681px 167.92509472370148px',
          }}
          id="elp0pxpuq0x99"
          className="animable"
        />
        <path
          d="M327.68,185c.42-2.13.7-4.28,1-6.43.51-3.74,8.89-17,8.89-17,2.7-5.25,5.86-10.36,10.26-14.23s10.2-6.39,16-5.74,11.28,4.93,12.41,10.74l-.93-1.49c.15,2.05-2.07,3.53-4.09,3.62s-4-.68-6-.8c-3.92-.25-7.7,2.08-10.06,5.29s-3.47,7.2-4.09,11.16-.79,8-1.51,11.92c-.76,4.22-3.21,5.61-6.48,8.31a62.69,62.69,0,0,0-8.58,8.66,5.51,5.51,0,0,1-4.47,1.74c-1.25-.32-1.54-2.21-1.68-3.52-.12-1.47.83-2.85,1-4.82a4.15,4.15,0,0,1-2-3.33A14,14,0,0,1,327.68,185Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '351.77978706359863px 171.1326503753662px',
          }}
          id="eljkw30juytmi"
          className="animable"
        />
        <path
          d="M346,180.63c-.18-.09-7.57-2.7-7.75,5s7.56,6.27,7.58,6.05S346,180.63,346,180.63Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '342.1234633922577px 186.02916717529297px',
          }}
          id="ele5uhr1b20ki"
          className="animable"
        />
        <path
          d="M343.59,188.69s-.14.09-.37.19a1.37,1.37,0,0,1-1,0c-.8-.31-1.45-1.62-1.46-3a4.42,4.42,0,0,1,.42-1.9,1.57,1.57,0,0,1,1-1,.69.69,0,0,1,.78.39c.1.22,0,.37.08.38s.17-.12.12-.44a.91.91,0,0,0-.29-.49,1,1,0,0,0-.74-.21,1.89,1.89,0,0,0-1.42,1.16,4.43,4.43,0,0,0-.51,2.12c0,1.55.77,3,1.87,3.36a1.45,1.45,0,0,0,1.22-.17C343.57,188.87,343.61,188.7,343.59,188.69Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '341.89698696136475px 185.95894265174866px',
          }}
          id="elyajymyujpm"
          className="animable"
        />
        <path
          d="M335.52,165.18a15.8,15.8,0,0,0,4.61-.38,19.42,19.42,0,0,0,4.63-1.93,51.06,51.06,0,0,0,5.17-3.42,55.74,55.74,0,0,1,5.19-3.5,20.15,20.15,0,0,1,4.7-2,11.66,11.66,0,0,1,3.43-.45,6.19,6.19,0,0,1,.94.08c.21,0,.32,0,.32.07a16.89,16.89,0,0,0-4.58.65,21,21,0,0,0-4.57,2.1,61.8,61.8,0,0,0-5.12,3.5,47.13,47.13,0,0,1-5.25,3.42,18.5,18.5,0,0,1-4.78,1.86,10.85,10.85,0,0,1-3.45.26,4.85,4.85,0,0,1-.93-.14C335.62,165.23,335.51,165.2,335.52,165.18Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '350.0147008895874px 159.48854732513428px',
          }}
          id="el38fk9td7fut"
          className="animable"
        />
        <path
          d="M333.54,168.22c0-.09,1.12.29,2.93.55a19.48,19.48,0,0,0,7.11-.34,19.24,19.24,0,0,0,3.69-1.32,18.12,18.12,0,0,0,2.75-1.65c1.48-1.09,2.24-2,2.31-1.9s-.14.26-.48.66a12.83,12.83,0,0,1-1.6,1.53,15.52,15.52,0,0,1-2.76,1.79,18.18,18.18,0,0,1-3.79,1.4,17.49,17.49,0,0,1-7.29.19,12.07,12.07,0,0,1-2.13-.58A2.55,2.55,0,0,1,333.54,168.22Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '342.9417152404785px 166.48878502845764px',
          }}
          id="elm10k2u4pvf"
          className="animable"
        />
        <path
          d="M336.33,163.77a29.61,29.61,0,0,1-2.2,3.83,31.46,31.46,0,0,1-2.3,3.77,13.74,13.74,0,0,1,1.85-4A13.91,13.91,0,0,1,336.33,163.77Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '334.0799865722656px 167.57000732421875px',
          }}
          id="elvn28ysw0cib"
          className="animable"
        />
        <path
          d="M388.78,165.64a6.18,6.18,0,0,1-6.23-2.16c.11-.12,1.24.9,3,1.49A26.77,26.77,0,0,0,388.78,165.64Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '385.6649932861328px 164.63589751720428px',
          }}
          id="elzi858xzxg8"
          className="animable"
        />
        <path
          d="M388.61,169.21a3.49,3.49,0,0,1-2.57.72,3.57,3.57,0,0,1-2.54-.82c.06-.14,1.15.28,2.55.3S388.55,169.07,388.61,169.21Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '386.0549774169922px 169.51812878251076px',
          }}
          id="elw3l8kr44hkk"
          className="animable"
        />
        <path
          d="M404.28,268.73l-19,15.36.81,5.29,4.09,12.14s4.95.64,11.45-7.34,14.24-23.33,14.24-23.33Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '400.5749969482422px 285.13113021850586px',
          }}
          id="elbcesa2oy5a"
          className="animable"
        />
        <path
          d="M440.44,233.18a1.89,1.89,0,0,0-1.59-1l-11.28-.47a3.47,3.47,0,0,0-2.63,1.09l-29.21,31,1.58,1.3,12.24,1.81,31.16-33.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '418.2200012207031px 249.30921173095703px',
          }}
          id="el336dlri0j66"
          className="animable"
        />
        <path
          d="M431.82,236.33a.79.79,0,0,0,1.2-1,.8.8,0,0,0-1.2,1Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '432.4324789047241px 235.84591627120972px',
          }}
          id="eltcyl96acz2"
          className="animable"
        />
        <path
          d="M440.71,233.67a15.9,15.9,0,0,1-2.21,0l-6-.15-4.14-.13a2.33,2.33,0,0,0-1.88.69l-1.67,1.79-7.46,7.94c-5.31,5.63-10.15,10.7-13.67,14.34l-4.2,4.29a13,13,0,0,1-1.61,1.52,13.57,13.57,0,0,1,1.42-1.69l4-4.44c3.44-3.73,8.22-8.85,13.53-14.48l7.5-7.91,1.7-1.77a2.84,2.84,0,0,1,2.31-.84l4.14.22,6,.36A12.84,12.84,0,0,1,440.71,233.67Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '419.28997802734375px 248.38806056976318px',
          }}
          id="el71y4mct4xkm"
          className="animable"
        />
        <path
          d="M426.22,244s-1-.36-2,2.23-4.14,10-4.14,10l-4.65-3.66-6.59-.33s-1.63,1.05-.73,1.94,4.84,2.35,4.84,2.35l2.22,4.85-7.86-5.7s-3,.23-2.48,2.13,5.33,8.44,5.33,8.44l-4.25-1.11-4.56-4s-1.59-.21-1.24,1.24,4.8,7.25,4.8,7.25l5.9,4.3s3.58.36,4.1-.61a12.17,12.17,0,0,0,.88-2.44s2-.17,2.48-1a5.61,5.61,0,0,0,.55-2.32s2.85,1.05,3.51-.53a18.91,18.91,0,0,0,.87-6.17c-.07-1.31,3.6-12.76,3.54-13.13S428.21,243.58,426.22,244Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '413.6525716781616px 258.98139572143555px',
          }}
          id="elssmr96yb5k"
          className="animable"
        />
        <path
          d="M415.17,273.34a3.68,3.68,0,0,1-1.78.22,11.58,11.58,0,0,1-7.81-3.41c-.77-.81-1.11-1.41-1.05-1.46s1.88,2,4.9,3.29S415.17,273.13,415.17,273.34Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '409.8466453552246px 271.1385090351105px',
          }}
          id="el72s38lzr0ry"
          className="animable"
        />
        <path
          d="M414.05,270.74c-.12.14-1.16-.67-2.2-1.9s-1.68-2.37-1.53-2.48,1,.85,2,2.05S414.19,270.61,414.05,270.74Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '412.18156909942627px 268.5535292625427px',
          }}
          id="el8whg1ry5nul"
          className="animable"
        />
        <path
          d="M418.46,265.78c-.12.13-1.15-.66-2.11-1.93s-1.43-2.48-1.27-2.56.88.93,1.81,2.15S418.6,265.64,418.46,265.78Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '416.7627966403961px 263.5397400856018px',
          }}
          id="elvdiyxgbywu"
          className="animable"
        />
        <path
          d="M422.85,261.93c-.19,0-.62-1.29-1.4-2.79s-1.61-2.64-1.47-2.77,1.24.85,2.06,2.46S423,261.9,422.85,261.93Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '421.4336051940918px 259.14424538612366px',
          }}
          id="el3ytscbfslj4"
          className="animable"
        />
        <path
          d="M394.26,309.86c-4.34-6.45-8.22-20.48-8.22-20.48s-1.69-12.85-3.8-17.64-1.52-6.75-1.52-6.75,1.77-12.74.59-19.15-4.17-21.22-9.43-27.57l-27.66-8.62s-15,7.11-16.35,8.7-11,9.57-11.2,21.22c-.14,7.28,5.3,33.74,5.3,33.74L328,323s20,9.32,39.19,5.34,30.21-13.72,30.21-13.72Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '357.03367614746094px 269.48940658569336px',
          }}
          id="eld0s6clpc0kh"
          className="animable"
        />
        <path
          d="M386.25,289.39a3.25,3.25,0,0,0-.05-.69c-.05-.45-.14-1.11-.26-2-.26-1.7-.65-4.16-1.32-7.18a82.26,82.26,0,0,0-3.06-10.42,13.51,13.51,0,0,1-.78-6.18c.16-2.19.6-4.44.8-6.8a62.68,62.68,0,0,0-2.83-23.83,57.36,57.36,0,0,0-2.68-6.84c-.35-.79-.68-1.39-.89-1.8a2.91,2.91,0,0,0-.35-.6,3.13,3.13,0,0,0,.25.65c.17.42.46,1,.78,1.83a69,69,0,0,1,2.49,6.87A64.94,64.94,0,0,1,381,256.11c-.2,2.31-.64,4.57-.79,6.8a13.84,13.84,0,0,0,.84,6.38,91.79,91.79,0,0,1,3.17,10.34c.72,3,1.17,5.45,1.49,7.14.15.8.27,1.44.37,2A3,3,0,0,0,386.25,289.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '380.5409412384033px 256.22000885009766px',
          }}
          id="eljgsy07axzk8"
          className="animable"
        />
        <path
          d="M377.65,240.17a63.72,63.72,0,0,1,.75,21.07,53.14,53.14,0,0,0-13,3.59q-.28-10.8-.55-21.61a1.67,1.67,0,0,1,.35-1.33,1.7,1.7,0,0,1,.94-.31l11.72-1.37"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.88476610183716px 252.49999237060547px',
          }}
          id="ellvxlqh9gg4b"
          className="animable"
        />
        <g id="el3pod660z10o">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '355.10590171813965px 295.83998107910156px',
            }}
            className="animable"
          >
            <path
              d="M383.07,276q-28.1,8.28-55.29,19.27l-.93,16.55c.84,2.4,3.51,3.78,6.06,3.86a17.31,17.31,0,0,0,7.33-1.9,124.33,124.33,0,0,0,37-24.82C380.79,285.52,384.43,280.83,383.07,276Z"
              id="ely9hbrl738j"
              style={{
                transformOrigin: '355.10590171813965px 295.83998107910156px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M335.14,219.4a7.11,7.11,0,0,0-9.48.21c-4.9,4.6-12.06,12.36-12.48,18.83-.63,9.9-3.07,36.06-3.07,36.06l36.49-.11s1.11-34.85-1.83-42.94C343.11,226.87,338.68,222.41,335.14,219.4Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '328.45770835876465px 246.0960807800293px',
          }}
          id="elyot6d9dj49i"
          className="animable"
        />
        <path
          d="M314.48,274.9s.21,20.16,3.54,29.05c3.46,9.18,8.12,8.51,12.11,8.34s62.52-39.88,62.52-39.88l-8.31-11.48-45.26,19.45-.37-5.62Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '353.56500244140625px 286.65005111694336px',
          }}
          id="el9trurcmmhsl"
          className="animable"
        />
        <path
          d="M384,261.34,393.63,246l9.88-3.5,12.52-.05a2.54,2.54,0,0,1-1.16,3l4.35-.24A2.47,2.47,0,0,1,418,248.6l3.15.2a4.46,4.46,0,0,1-4.53,3.09,68,68,0,0,0-9.22.43l-5.68,4,9-1.4,6.69.49s1.06,1.57-.38,2.14-7.17.82-7.17.82l-8.4,3.24s-1.22,5.77-2.2,7.14-7,3.67-7,3.67Z"
          style={{
            fill: 'rgb(255, 213, 190)',
            transformOrigin: '402.5749969482422px 257.43502044677734px',
          }}
          id="elsl2j6tyf9km"
          className="animable"
        />
        <path
          d="M419.22,245.21a17.37,17.37,0,0,1-3.38.25c-2.08.08-5,.13-8.15.15h-3.06l.13,0c-2.27.93-4.24,1.71-5.65,2.24a10.49,10.49,0,0,1-2.3.74,9.47,9.47,0,0,1,2.14-1.12c1.37-.64,3.3-1.49,5.56-2.46l.05,0h.07l3.06,0c3.18,0,6.06,0,8.15.05A16.27,16.27,0,0,1,419.22,245.21Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '408.01502990722656px 246.80001068115234px',
          }}
          id="eli31klnkt3ri"
          className="animable"
        />
        <path
          d="M420.38,248.75a14.16,14.16,0,0,1-3.07.14c-1.89,0-4.51,0-7.4-.14l-2.87-.1.16,0c-3.88,2-6.76,3.45-6.83,3.31s2.68-1.76,6.52-3.88l.08,0h.09l2.87.08c2.89.09,5.5.21,7.39.33A14.68,14.68,0,0,1,420.38,248.75Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '410.3743562698364px 250.0246570110321px',
          }}
          id="elfbm1o4zwow8"
          className="animable"
        />
        <path
          d="M392.26,272.45a7.17,7.17,0,0,1,.95-.45c.63-.28,1.57-.69,2.75-1.28.59-.29,1.24-.63,1.92-1.05a8.49,8.49,0,0,0,1-.73,3.06,3.06,0,0,0,.65-1.12,44.55,44.55,0,0,0,1.68-6.23l0-.11.11-.05,8.38-3.28h.09c1.48-.07,3.05-.18,4.66-.37a12.46,12.46,0,0,0,2.39-.44.79.79,0,0,0,.59-.68,1.9,1.9,0,0,0-.33-1l.23.13-6.7-.47h.07l-9,1.41-1.38.22,1.14-.81,5.68-4,.07,0h.08c2.29-.24,4.72-.43,7.19-.47.68,0,1.37,0,2.05.05a4.67,4.67,0,0,0,1.83-.26,4.29,4.29,0,0,0,2.4-2.6l.3.43-3.15-.19-1.16-.08,1-.55a2.52,2.52,0,0,0,1.22-1.26,2.25,2.25,0,0,0-.11-1.69l.31.17-4.36.24-1.19.07,1-.66a2.49,2.49,0,0,0,1-1.16,2.13,2.13,0,0,0,0-1.47l.3.2-12.52,0,.09,0-9.89,3.46.12-.09-7.15,11.18-2,3-.53.77c-.12.17-.18.26-.19.25a1.27,1.27,0,0,1,.14-.29l.47-.8,1.85-3.08c1.67-2.71,4.05-6.55,7-11.3l.05-.07.08,0,9.85-3.55h.09l12.52-.09h.23l.07.2a2.84,2.84,0,0,1,0,1.93,3.21,3.21,0,0,1-1.25,1.47l-.19-.59,4.35-.25h.22l.09.18a2.9,2.9,0,0,1,.15,2.22,3.23,3.23,0,0,1-1.52,1.63l-.14-.63,3.15.19.45,0-.15.4a5,5,0,0,1-2.8,3,5.25,5.25,0,0,1-2.11.3c-.66,0-1.33,0-2,0-2.44,0-4.86.22-7.12.46l.15-.06-5.68,4-.24-.59,9-1.38h.07l6.69.51h.16l.07.12a2.46,2.46,0,0,1,.41,1.42,1.39,1.39,0,0,1-1,1.17,12.66,12.66,0,0,1-2.53.46c-1.64.18-3.21.27-4.71.34l.08,0-8.41,3.2.13-.16a42.51,42.51,0,0,1-1.8,6.27,3.28,3.28,0,0,1-.75,1.22,6.36,6.36,0,0,1-1.06.74c-.7.42-1.37.74-2,1-1.2.55-2.15.93-2.8,1.18l-.74.26A.72.72,0,0,1,392.26,272.45Z"
          style={{
            fill: 'rgb(255, 177, 148)',
            transformOrigin: '402.6800079345703px 257.40504455566406px',
          }}
          id="elnuejk2rpnb"
          className="animable"
        />
        <path
          d="M309.49,274.48a2.45,2.45,0,0,1,.61-.06l1.77-.05,6.6-.11,22.63-.14-.33.3c.19-3.16.24-6.54.17-10-.1-5.74-.43-11.22-.59-16.2-.09-2.5-.09-4.87-.22-7.07a41.28,41.28,0,0,0-.74-6.08,23,23,0,0,0-3.27-8.17c-1.18-1.74-2.06-2.52-2-2.56a3.15,3.15,0,0,1,.64.55,14.22,14.22,0,0,1,1.58,1.86,22.08,22.08,0,0,1,3.52,8.22,40.47,40.47,0,0,1,.84,6.14c.16,2.23.17,4.6.28,7.08.2,5,.54,10.45.65,16.22.07,3.49,0,6.89-.19,10.07l0,.31h-.31l-22.63-.09-6.6-.09-1.77,0A2.45,2.45,0,0,1,309.49,274.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '325.5732841491699px 249.56501007080078px',
          }}
          id="elffcfjovmbg"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-2--inject-103"
        style={{ transformOrigin: '209.61998748779297px 127.19262886047363px' }}
        className="animable"
      >
        <path
          d="M161.51,107.81s.91-1.2,2.78-3.4a82.78,82.78,0,0,1,9-8.83A78.49,78.49,0,0,1,190,84.78a71.85,71.85,0,0,1,25.41-6.89,66.29,66.29,0,0,1,15.36.64,59.71,59.71,0,0,1,15.89,5,57.81,57.81,0,0,1,26.11,25.16c6.11,11.48,8.54,25.53,6.77,39.54a81.64,81.64,0,0,1-51.74,65.31c-13.24,4.93-27.47,5.77-40.05,2.45a57.82,57.82,0,0,1-30.47-19.66A60.32,60.32,0,0,1,148.84,182a65.82,65.82,0,0,1-4.13-14.81,71.44,71.44,0,0,1,.9-26.31,77.69,77.69,0,0,1,6.69-18.76,82.37,82.37,0,0,1,6.53-10.78c1.71-2.32,2.68-3.49,2.68-3.49l-.66.91c-.42.6-1.11,1.46-1.93,2.64a84.92,84.92,0,0,0-6.44,10.81,78.15,78.15,0,0,0-6.58,18.73,71.35,71.35,0,0,0-.83,26.19,65.31,65.31,0,0,0,4.14,14.71A60,60,0,0,0,157.65,196,57.46,57.46,0,0,0,187.9,215.5c12.48,3.28,26.6,2.43,39.75-2.47a81.25,81.25,0,0,0,51.42-64.89c1.76-13.92-.65-27.86-6.7-39.26a57.45,57.45,0,0,0-25.86-25,59.61,59.61,0,0,0-15.78-5,66,66,0,0,0-15.26-.66,71.38,71.38,0,0,0-25.32,6.79,78.41,78.41,0,0,0-16.73,10.69,85.18,85.18,0,0,0-9,8.74c-1,1.07-1.64,1.93-2.13,2.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '212.00015258789062px 147.8437271118164px',
          }}
          id="elejh6ijluft"
          className="animable"
        />
        <g id="elg6qoz6r3rbd">
          <ellipse
            cx="209.62"
            cy="143.19"
            rx="60.61"
            ry="53.34"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '209.62px 143.19px',
              transform: 'rotate(-51.61deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M167.82,110.07s.75-1,2.3-2.83a68.56,68.56,0,0,1,7.45-7.32,64.69,64.69,0,0,1,13.86-9,59.48,59.48,0,0,1,21.06-5.72,54.44,54.44,0,0,1,12.72.53,49.68,49.68,0,0,1,13.18,4.11A48,48,0,0,1,260,110.75a55.54,55.54,0,0,1,5.61,32.78,67.63,67.63,0,0,1-42.88,54.12,55.46,55.46,0,0,1-33.2,2,47.92,47.92,0,0,1-25.25-16.3,49.91,49.91,0,0,1-7-11.89,55,55,0,0,1-3.41-12.27,59.29,59.29,0,0,1,.75-21.8,65,65,0,0,1,5.55-15.55A68.56,68.56,0,0,1,165.6,113c1.42-1.92,2.22-2.88,2.22-2.88l-.54.75c-.35.5-.92,1.21-1.6,2.19a71.8,71.8,0,0,0-5.32,8.95,65.24,65.24,0,0,0-5.45,15.52,59.22,59.22,0,0,0-.67,21.68,54.77,54.77,0,0,0,3.42,12.18,50.05,50.05,0,0,0,7,11.77,47.57,47.57,0,0,0,25,16.11,55.19,55.19,0,0,0,32.9-2,67.27,67.27,0,0,0,42.56-53.72A55.14,55.14,0,0,0,259.61,111,47.59,47.59,0,0,0,238.2,90.28a49.45,49.45,0,0,0-13-4.11,54.32,54.32,0,0,0-12.64-.55,59.32,59.32,0,0,0-20.95,5.61,65.22,65.22,0,0,0-13.86,8.85,71,71,0,0,0-7.5,7.23c-.8.88-1.36,1.6-1.77,2.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '209.65541076660156px 143.17124938964844px',
          }}
          id="elcd2c4ct1ist"
          className="animable"
        />
        <path
          d="M174.06,41a5.84,5.84,0,0,0-10.47.91,10.42,10.42,0,0,1-1,2.57c-1.49,2-5.19,1.43-6.39,3.64s1.67,5.16,1,7.74c-.57,2.06-3.22,3-3.82,5-.8,2.72,2.47,5.41,1.69,8.13-.68,2.34-4,3.21-4.5,5.58-.57,2.63,2.66,4.77,2.61,7.46-.07,3.44-5.32,5.33-4.84,8.74.27,1.88,2.27,3.14,2.61,5,.63,3.52-4.82,6-4.17,9.49C147,106.91,148.6,108,150,109s2.75,2.43,2.48,4.09-2.2,2.65-3.24,4.07c-1.61,2.18.94,7.84,3.42,8.93l10.3-7.7s-2.95-2.46-.64-4.72.82-3.27.73-5c0,0,2.3,1.93,1.45,4a5,5,0,0,0,.54,4.8l15.71-7,1.69-14.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '164.58301544189453px 82.12177658081055px',
          }}
          id="elyedeg1y33g"
          className="animable"
        />
        <path
          d="M151.14,110.35a4,4,0,0,1-1,.05,6.32,6.32,0,0,1-2.74-.82,6.2,6.2,0,0,1-2.85-3.47,6.33,6.33,0,0,1-.29-2.84,8.79,8.79,0,0,1,1.05-3c.52-1,1.16-2,1.64-3.07a6.26,6.26,0,0,0,.6-3.58c-.22-1.26-1.18-2.27-1.94-3.45a3.55,3.55,0,0,1-.68-2.08,2.53,2.53,0,0,1,1.16-1.92,15.27,15.27,0,0,1,2-1.09,3.79,3.79,0,0,0,1.64-1.39,2.72,2.72,0,0,0,.15-2.12,6.75,6.75,0,0,0-1-2.06c-.45-.64-1-1.27-1.41-2a5.46,5.46,0,0,1-.93-2.35,3.42,3.42,0,0,1,.77-2.45A10.32,10.32,0,0,1,149.19,71a12,12,0,0,0,1.93-1.57,3.11,3.11,0,0,0,.94-2.09,5.09,5.09,0,0,0-.66-2.25c-.36-.71-.8-1.4-1.15-2.13a4.38,4.38,0,0,1-.53-2.39,3.06,3.06,0,0,1,.36-1.18,5.78,5.78,0,0,1,.73-1c1.1-1.11,2.49-1.87,3.08-3.17a3.61,3.61,0,0,0,.25-2,9.9,9.9,0,0,0-.52-2,9.08,9.08,0,0,1-.76-4,3.1,3.1,0,0,1,.85-1.8,3.78,3.78,0,0,1,1.65-1c1.19-.36,2.37-.41,3.43-.66a4,4,0,0,0,2.56-1.57c.55-.81.84-1.73,1.38-2.46a5.8,5.8,0,0,1,6.7-1.93,5,5,0,0,1,.67.34l.21.14s-.3-.18-.91-.41a5.71,5.71,0,0,0-2.79-.25,5.47,5.47,0,0,0-3.7,2.23c-.51.71-.79,1.62-1.36,2.48a4.13,4.13,0,0,1-2.69,1.69c-1.1.28-2.27.33-3.41.68a3.5,3.5,0,0,0-1.52.89,2.78,2.78,0,0,0-.75,1.62,8.75,8.75,0,0,0,.77,3.87,11.53,11.53,0,0,1,.54,2.08,4.06,4.06,0,0,1-.27,2.22c-.67,1.45-2.11,2.21-3.14,3.28a4.36,4.36,0,0,0-.67.88,2.74,2.74,0,0,0-.32,1,4.12,4.12,0,0,0,.5,2.19c.34.7.77,1.38,1.15,2.12a5.41,5.41,0,0,1,.71,2.42,3.66,3.66,0,0,1-1,2.36,13.23,13.23,0,0,1-2,1.61A10.07,10.07,0,0,0,147.56,73a3.06,3.06,0,0,0-.7,2.18,5.27,5.27,0,0,0,.87,2.18c.43.68.94,1.29,1.41,2a7.38,7.38,0,0,1,1.07,2.18,3.09,3.09,0,0,1-.19,2.4,4.12,4.12,0,0,1-1.79,1.53,16.06,16.06,0,0,0-1.93,1.06,2.17,2.17,0,0,0-1,1.66A3.18,3.18,0,0,0,145.9,90c.72,1.14,1.72,2.19,2,3.57a6.52,6.52,0,0,1-.64,3.76c-.5,1.13-1.15,2.1-1.66,3.08a8.76,8.76,0,0,0-1.06,2.92,6.36,6.36,0,0,0,.25,2.74,6.14,6.14,0,0,0,2.72,3.41,6.7,6.7,0,0,0,2.68.87C150.8,110.37,151.14,110.33,151.14,110.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '157.26001453399658px 73.91510391235352px',
          }}
          id="elrr73b1z05b"
          className="animable"
        />
        <path
          d="M151.62,121.63a1.21,1.21,0,0,1-.21-.15,1.11,1.11,0,0,1-.32-.69,2,2,0,0,1,.27-1.2,2.41,2.41,0,0,1,1.35-1c.6-.22,1.31-.3,2-.48a3.07,3.07,0,0,0,2-1.26,1.47,1.47,0,0,0,.07-1.25,5.51,5.51,0,0,0-.74-1.23,3.18,3.18,0,0,1-.65-1.47,2.72,2.72,0,0,1,.41-1.64c.27-.51.61-1,.91-1.48a3.11,3.11,0,0,0,.53-1.6,2.42,2.42,0,0,0-.75-1.56c-.42-.46-.93-.87-1.38-1.38a2.29,2.29,0,0,1-.69-2,1.82,1.82,0,0,1,.51-1,3.74,3.74,0,0,1,.9-.63c.65-.32,1.33-.55,2-.83a3.93,3.93,0,0,0,1.69-1.21,2.42,2.42,0,0,0,.31-2,14.13,14.13,0,0,0-.79-2.13,9,9,0,0,1-.73-2.29,4.77,4.77,0,0,1,.41-2.44c.64-1.51,1.74-2.82,2.08-4.4a3.66,3.66,0,0,0-.31-2.34,24.7,24.7,0,0,0-1.26-2.2,5.34,5.34,0,0,1-.89-2.47,3.8,3.8,0,0,1,.88-2.44c.51-.69,1.11-1.27,1.62-1.9a4.08,4.08,0,0,0,1-2.06,3.72,3.72,0,0,0-.55-2.18c-.37-.68-.83-1.32-1.22-2a4.33,4.33,0,0,1-.66-2.28,4.55,4.55,0,0,1,.78-2.18c.4-.64.83-1.23,1.14-1.86a2.91,2.91,0,0,0,.29-2c-.29-1.32-1.32-2.38-1.57-3.76a2.62,2.62,0,0,1,.43-2,9.68,9.68,0,0,1,1.28-1.41A6.49,6.49,0,0,0,162.92,52a3.49,3.49,0,0,0,.43-1.58c0-1.1-.21-2.16-.14-3.2a6,6,0,0,1,.87-2.75,5.71,5.71,0,0,1,3.67-2.64,6,6,0,0,1,2.9.08,4.07,4.07,0,0,1,.93.39s-.32-.15-1-.31a5.9,5.9,0,0,0-2.84,0,5.58,5.58,0,0,0-3.53,2.6,5.85,5.85,0,0,0-.81,2.65c0,1,.2,2,.17,3.2a3.71,3.71,0,0,1-.45,1.72,6.59,6.59,0,0,1-1.18,1.4,8.81,8.81,0,0,0-1.23,1.37,2.33,2.33,0,0,0-.38,1.74c.22,1.26,1.25,2.3,1.6,3.75a3.34,3.34,0,0,1-.32,2.19c-.32.67-.76,1.27-1.14,1.9a4.16,4.16,0,0,0-.73,2,4,4,0,0,0,.63,2.08c.37.67.83,1.31,1.22,2a4,4,0,0,1,.59,2.41,4.41,4.41,0,0,1-1.1,2.26c-.53.64-1.13,1.22-1.61,1.88a3.47,3.47,0,0,0-.81,2.2,5.15,5.15,0,0,0,.84,2.29,23.08,23.08,0,0,1,1.28,2.23,4.14,4.14,0,0,1,.34,2.57c-.38,1.73-1.5,3-2.11,4.48a4.28,4.28,0,0,0-.38,2.24,8.38,8.38,0,0,0,.69,2.2,13.62,13.62,0,0,1,.8,2.19,2.79,2.79,0,0,1-.36,2.3,4.34,4.34,0,0,1-1.85,1.32c-.67.29-1.35.51-2,.82a1.78,1.78,0,0,0-.63,3.06c.42.48.93.89,1.37,1.38a2.74,2.74,0,0,1,.82,1.76,3.31,3.31,0,0,1-.59,1.76c-.31.51-.65,1-.91,1.46a2.48,2.48,0,0,0-.39,1.49,2.78,2.78,0,0,0,.59,1.35,6,6,0,0,1,.76,1.29,1.7,1.7,0,0,1-.1,1.43,3.18,3.18,0,0,1-2.11,1.34c-.76.17-1.45.24-2,.44a2.27,2.27,0,0,0-1.3.92,1.94,1.94,0,0,0-.3,1.13A1.27,1.27,0,0,0,151.62,121.63Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '161.33081531524658px 81.65990447998047px',
          }}
          id="el73fzldv9z0u"
          className="animable"
        />
        <path
          d="M170,189.06c4.67,5,19.84,10.47,19.84,10.47l-6.8-11.38L174.63,150l-5.58-35.9c-.46.57-14,9.19-16,14.74s1.43,31.19,2,35.11A48.93,48.93,0,0,0,170,189.06Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '171.13505935668945px 156.81499862670898px',
          }}
          id="el2j4b0dztgac"
          className="animable"
        />
        <path
          d="M177.21,101.72l-1.06,6.67-10,8A114.52,114.52,0,0,0,166,146.8s14.62,39.64,15,41.37c.66,3.21,8.87,11.36,8.87,11.36s11.13,3.89,28.19-.6c15.94-4.2,28.19-17.42,29.93-19s6.92-8.81,6.92-8.81L235.6,131.67l-.77-26.86-20.37-5.23-6.92-5.35Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '209.98484802246094px 147.6619644165039px',
          }}
          id="eluo0bbawwmsq"
          className="animable"
        />
        <path
          d="M234.5,104.85s11.28,3.91,14.23,10.68,13,35.33,13.23,41.21c0,.79-4.08,12.9-7.38,14.88-4.39,2.64-11-3.36-11-3.36L239,160.8l.25-7.82-5.21-20.82Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '247.99999237060547px 138.57058334350586px',
          }}
          id="el75564wrfzvr"
          className="animable"
        />
        <path
          d="M177.65,105s23.29,28.54,23.29,28.54l3.17-26.4,4.41-13-30.33,7.5Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '193.08499908447266px 113.84000778198242px',
          }}
          id="elgnkhrbry7b4"
          className="animable"
        />
        <path
          d="M200.83,134.43a2,2,0,0,1-.22-.25l-.59-.77c-.52-.67-1.28-1.65-2.28-2.86a94.3,94.3,0,0,0-8.8-9.37l.34-.14c-.09,3.86-.2,8.2-.3,12.77,0,.41,0,.81,0,1.18l0,.9-.4-.81c-3.57-7.35-6.79-14-9.13-18.77l-2.71-5.67-.72-1.55a3.63,3.63,0,0,1-.22-.55,2.87,2.87,0,0,1,.3.51c.2.38.46.89.79,1.51l2.83,5.62,9.26,18.71-.42.09c0-.37,0-.78,0-1.18.12-4.57.23-8.91.34-12.77v-.45l.32.31a84.87,84.87,0,0,1,8.72,9.51c1,1.24,1.7,2.24,2.19,2.94l.54.8A1.12,1.12,0,0,1,200.83,134.43Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '188.31499481201172px 122.2149658203125px',
          }}
          id="elg9lmpir8a9n"
          className="animable"
        />
        <path
          d="M234,155c.08.08-6.72,7.36-15.19,16.26s-15.42,16-15.51,15.95S210,179.89,218.5,171,233.92,155,234,155Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '218.6499080657959px 171.10512733459473px',
          }}
          id="eltzmxuq61rrc"
          className="animable"
        />
        <path
          d="M221.36,191.73a20,20,0,0,1-.66-2.65c-.38-1.63-.95-3.88-1.74-6.31s-1.65-4.59-2.3-6.13a26.73,26.73,0,0,1-1-2.52,12.4,12.4,0,0,1,1.31,2.39,51.55,51.55,0,0,1,2.44,6.13A53.14,53.14,0,0,1,221,189,14.47,14.47,0,0,1,221.36,191.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '218.510009765625px 182.92499542236328px',
          }}
          id="el2k3c9m6si9t"
          className="animable"
        />
        <path
          d="M164.25,145.4a51.93,51.93,0,0,1-5.66-3.58,51.14,51.14,0,0,1-5.42-3.93,51.58,51.58,0,0,1,5.66,3.57A49.12,49.12,0,0,1,164.25,145.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '158.71001434326172px 141.64500427246094px',
          }}
          id="ell3s1tq5xi4"
          className="animable"
        />
        <path
          d="M254.58,173.16a1.16,1.16,0,0,1-.3,0h-.87a7.46,7.46,0,0,1-1.39-.11,10.81,10.81,0,0,1-1.83-.41,12.13,12.13,0,0,1-4.35-2.52,15.12,15.12,0,0,1-3.73-5.26h0c-.79-3.21-1.67-6.77-2.6-10.51L235.08,136c-.54-2.31-1-4.2-1.29-5.57-.14-.62-.25-1.13-.33-1.52a3.57,3.57,0,0,1-.09-.53,2.09,2.09,0,0,1,.17.51c.11.39.24.88.41,1.5l1.43,5.53c1.18,4.73,2.78,11.18,4.55,18.3.91,3.75,1.78,7.32,2.56,10.52v0a15,15,0,0,0,3.58,5.15,12.25,12.25,0,0,0,4.2,2.54A17.31,17.31,0,0,0,254.58,173.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '243.97500610351562px 150.77487754821777px',
          }}
          id="el0jwtxcmkbcdv"
          className="animable"
        />
        <path
          d="M172.18,173.68a16.53,16.53,0,0,1-1.66.37,11.47,11.47,0,0,0-6.58,4.48c-.61.86-.89,1.45-.95,1.42a4.09,4.09,0,0,1,.69-1.59,10.12,10.12,0,0,1,2.9-3,10,10,0,0,1,3.87-1.59A4,4,0,0,1,172.18,173.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '167.58499145507812px 176.78794527053833px',
          }}
          id="els1j47hi5n6"
          className="animable"
        />
        <path
          d="M172.33,172.72a17.86,17.86,0,0,1-8.15,2c0-.13,1.85-.39,4.09-.95S172.28,172.6,172.33,172.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.25499725341797px 173.71236371994019px',
          }}
          id="el8skk2xmb5hg"
          className="animable"
        />
        <path
          d="M216.54,172.46a1.54,1.54,0,0,1-.23-.35l-.59-1c-.51-.9-1.21-2.22-2.05-3.87-1.69-3.29-3.88-7.91-6-13.12s-3.89-10-5-13.54c-.57-1.76-1-3.19-1.3-4.19-.12-.45-.23-.83-.31-1.15a2,2,0,0,1-.09-.4s.07.12.17.38l.4,1.12c.35,1,.84,2.44,1.42,4.14,1.22,3.48,3,8.27,5.14,13.47s4.32,9.83,5.93,13.15l1.92,3.93.52,1.07C216.5,172.32,216.56,172.45,216.54,172.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '208.75699758529663px 153.65001678466797px',
          }}
          id="ellazum0yj8g"
          className="animable"
        />
        <g id="el62gqihw9ik4">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '218.06500244140625px 171.77000427246094px',
            }}
            className="animable"
          >
            <path
              d="M203.53,186.77c12.24-6.67,23.15-17.41,29.07-30Z"
              id="elr1gxtc7lxga"
              style={{
                transformOrigin: '218.06500244140625px 171.77000427246094px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elq33qzkj2uyb">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '168.8519787788391px 176.07751941680908px',
            }}
            className="animable"
          >
            <path
              d="M163,180c2.39-5.14,7.1-6.56,11.69-6.49a1.12,1.12,0,0,0-.79-1.25,3.14,3.14,0,0,0-1.61,0,18,18,0,0,0-6.33,2.17,6.32,6.32,0,0,0-2.89,5.39"
              id="elo5v2pjghdnm"
              style={{
                transformOrigin: '168.8519787788391px 176.07751941680908px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el4qn09out1b2">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '187.98500061035156px 124.77499008178711px',
            }}
            className="animable"
          >
            <path
              d="M175.89,108.68a115.73,115.73,0,0,0,14.36,32.19,18.57,18.57,0,0,0,2.83-12.34,14.3,14.3,0,0,0,7,4.91,67.4,67.4,0,0,0-10.84-12.26s-.37,14.32-.35,13.95c-4.42-8.87-8.71-17.6-13-26.45"
              id="elcgwrxshg4yt"
              style={{
                transformOrigin: '187.98500061035156px 124.77499008178711px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M190.26,196.47s-.09-.14-.21-.44-.3-.79-.51-1.32c-.41-1.14-1.06-2.79-1.87-4.82-1.63-4-4.1-9.55-6.95-15.58s-5.39-11.52-7-15.59c-.82-2-1.45-3.68-1.84-4.85-.17-.53-.32-1-.44-1.33a1.5,1.5,0,0,1-.12-.48,2.29,2.29,0,0,1,.22.44l.53,1.3c.45,1.14,1.13,2.77,2,4.78,1.71,4,4.29,9.47,7.14,15.51s5.28,11.57,6.82,15.67c.77,2.05,1.37,3.72,1.73,4.89l.41,1.34A1.61,1.61,0,0,1,190.26,196.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '180.79000854492188px 174.2649917602539px',
          }}
          id="eleqrixpyu8id"
          className="animable"
        />
        <path
          d="M173.32,157.45c0,.08-1.1-.24-2.85-.53a25.9,25.9,0,0,0-13.65,1.44c-1.66.65-2.64,1.18-2.68,1.11s.21-.2.64-.46a15.35,15.35,0,0,1,1.89-1,22.71,22.71,0,0,1,13.86-1.46,14.59,14.59,0,0,1,2.06.57C173.07,157.3,173.33,157.41,173.32,157.45Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '163.7280559539795px 157.77087950706482px',
          }}
          id="el520hmjseis"
          className="animable"
        />
        <path
          d="M182.2,177.77a34,34,0,0,0-8.5,2.56,34.7,34.7,0,0,0-7.26,5.13,8.86,8.86,0,0,1,1.76-2,21.95,21.95,0,0,1,11.36-5.55A8.72,8.72,0,0,1,182.2,177.77Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '174.3199920654297px 181.59357070922852px',
          }}
          id="ell8xl8xnz5y"
          className="animable"
        />
        <path
          d="M206.19,151.93c.07.13-6.23,3.49-14.06,7.51s-14.24,7.17-14.3,7,6.23-3.49,14.06-7.51S206.13,151.8,206.19,151.93Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '192.01007652282715px 159.18630361557007px',
          }}
          id="elk1q7vg36num"
          className="animable"
        />
        <path
          d="M235,136.63c0,.14-6.77,2.11-15.22,4.4s-15.32,4-15.35,3.91,6.77-2.12,15.22-4.41S235,136.49,235,136.63Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '219.7149543762207px 140.78278160095215px',
          }}
          id="eltyenxmwmo0g"
          className="animable"
        />
        <path
          d="M262.17,155.88s-.22.23-.67.57a14.83,14.83,0,0,1-2,1.27,21.1,21.1,0,0,1-3.3,1.37,23.09,23.09,0,0,1-4.29.86,22.67,22.67,0,0,1-4.38,0,20.06,20.06,0,0,1-3.49-.73,14.37,14.37,0,0,1-2.24-.86,3.05,3.05,0,0,1-.77-.44c0-.09,1.17.44,3.11.95a21.53,21.53,0,0,0,3.44.6,24.4,24.4,0,0,0,4.28,0,25.26,25.26,0,0,0,4.2-.8,22.83,22.83,0,0,0,3.27-1.24C261.1,156.53,262.12,155.8,262.17,155.88Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '251.60000610351562px 157.96500754356384px',
          }}
          id="elmgawac4ejgg"
          className="animable"
        />
        <path
          d="M246.8,171a4.6,4.6,0,0,1-.83.83c-.55.51-1.38,1.22-2.44,2a60.48,60.48,0,0,1-8.84,5.69,59.35,59.35,0,0,1-9.7,4c-1.28.4-2.34.69-3.07.85a4.57,4.57,0,0,1-1.15.21,5,5,0,0,1,1.1-.4c.71-.23,1.74-.56,3-1a70.42,70.42,0,0,0,18.44-9.67c1.08-.79,1.94-1.44,2.53-1.9A5.32,5.32,0,0,1,246.8,171Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '233.78500366210938px 177.79000091552734px',
          }}
          id="el1yrztxx4mt"
          className="animable"
        />
        <path
          d="M219.35,188.81a5.34,5.34,0,0,1-1,.6c-.69.36-1.7.83-3,1.38a69.19,69.19,0,0,1-20.93,5.32c-1.38.12-2.5.18-3.27.2a6.33,6.33,0,0,1-1.21,0,5,5,0,0,1,1.19-.18c.77-.07,1.88-.19,3.25-.36a86.48,86.48,0,0,0,10.59-2,85.09,85.09,0,0,0,10.24-3.32c1.29-.5,2.32-.93,3-1.23A4.76,4.76,0,0,1,219.35,188.81Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '204.64500427246094px 192.5744857788086px',
          }}
          id="elpl8y803thbq"
          className="animable"
        />
        <path
          d="M180.82,128.41a29.15,29.15,0,0,1-3.1,1.91c-1.93,1.14-4.61,2.72-7.53,4.51s-5.53,3.47-7.42,4.69a24.65,24.65,0,0,1-3.11,1.9,4.19,4.19,0,0,1,.75-.63c.5-.39,1.23-.93,2.15-1.57,1.85-1.3,4.43-3,7.36-4.83s5.64-3.33,7.62-4.39c1-.53,1.81-.94,2.38-1.22A3.58,3.58,0,0,1,180.82,128.41Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '170.24000549316406px 134.91500091552734px',
          }}
          id="elrx7sudy6t7"
          className="animable"
        />
        <path
          d="M182.72,114.13a5,5,0,0,1-.54,2.2c-.44,1.16-.9,2.07-1,2a5.11,5.11,0,0,1,.55-2.2C182.13,115,182.59,114.08,182.72,114.13Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '181.95000457763672px 116.23091506958008px',
          }}
          id="elcglt2fzb5kk"
          className="animable"
        />
        <path
          d="M230.17,112.71c0,.13-6,2.09-13.53,4.37S203,121.09,203,121s6-2.09,13.53-4.37S230.13,112.57,230.17,112.71Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '216.58499908447266px 116.85281276702881px',
          }}
          id="el69nlbpuhffb"
          className="animable"
        />
        <g id="elm7rfxlpdmpl">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '181.8899917602539px 177.38999938964844px',
            }}
            className="animable"
          >
            <path
              d="M173.12,157.62l17.54,39.54A58.26,58.26,0,0,0,173.12,157.62Z"
              id="elc3yos0pgxcj"
              style={{
                transformOrigin: '181.8899917602539px 177.38999938964844px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M198,48,174.59,43.8c-7.41-.27-11.68,9.12-11.64,16.54.05,8.24.43,18.29,1.82,24.35,2.8,12.17,12.34,13.09,12.34,13.09s.54,7.21.54,7.21l24.3.39.19-53.22A4.35,4.35,0,0,0,198,48Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '182.54486274719238px 74.5871524810791px',
          }}
          id="el5k2xkgudwqm"
          className="animable"
        />
        <path
          d="M167.3,69.11a1.56,1.56,0,0,0,1.63,1.48,1.52,1.52,0,0,0,1.53-1.53,1.59,1.59,0,0,0-1.63-1.49A1.51,1.51,0,0,0,167.3,69.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.87985968589783px 69.08055365085602px',
          }}
          id="elu9dl6owyal"
          className="animable"
        />
        <path
          d="M165.68,64.61c.21.2,1.34-.77,3-.88s3,.65,3.17.43-.14-.46-.71-.82a4.42,4.42,0,0,0-2.55-.6,4.17,4.17,0,0,0-2.41,1C165.73,64.14,165.58,64.53,165.68,64.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.77342295646667px 63.68316042423248px',
          }}
          id="el55epwaapms"
          className="animable"
        />
        <path
          d="M182.81,69.11a1.56,1.56,0,0,0,1.63,1.48A1.52,1.52,0,0,0,186,69.06a1.59,1.59,0,0,0-1.63-1.49A1.51,1.51,0,0,0,182.81,69.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '184.40485441684723px 69.08042800426483px',
          }}
          id="el66gx95geurl"
          className="animable"
        />
        <path
          d="M182.45,64.58c.21.19,1.35-.77,3.05-.88s3,.65,3.17.43-.14-.46-.71-.82a4.45,4.45,0,0,0-2.56-.6,4.1,4.1,0,0,0-2.4,1C182.5,64.11,182.35,64.5,182.45,64.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '185.56861114501953px 63.65200632810593px',
          }}
          id="ela498dffltx"
          className="animable"
        />
        <path
          d="M177.15,77.6a10.9,10.9,0,0,0-2.79-.31c-.44,0-.85-.07-1-.36a2.3,2.3,0,0,1,.2-1.31c.34-1.07.69-2.2,1.06-3.39,1.46-4.82,2.48-8.78,2.29-8.83s-1.54,3.8-3,8.63c-.35,1.19-.69,2.32-1,3.4a2.51,2.51,0,0,0-.1,1.72,1.08,1.08,0,0,0,.75.59,3.4,3.4,0,0,0,.75.05A11.07,11.07,0,0,0,177.15,77.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '174.9267716407776px 70.60543441772461px',
          }}
          id="el7xz1bkzi245"
          className="animable"
        />
        <path
          d="M177.08,97.78a31.31,31.31,0,0,0,16.18-5.53s-3.57,8.75-16,8.45Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '185.17001342773438px 96.47876930236816px',
          }}
          id="el7was3yc0uk8"
          className="animable"
        />
        <path
          d="M181.34,60.21c.2.45,1.88.12,3.89.22s3.66.54,3.9.11c.1-.21-.21-.63-.89-1a6.6,6.6,0,0,0-2.94-.81,6.53,6.53,0,0,0-3,.57C181.6,59.61,181.26,60,181.34,60.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '185.23844265937805px 59.72379744052887px',
          }}
          id="el82woz4f324b"
          className="animable"
        />
        <path
          d="M166,60.45c.33.37,1.47-.11,2.88-.23s2.61.08,2.86-.34c.11-.2-.11-.58-.65-.91a4,4,0,0,0-2.39-.47,4.11,4.11,0,0,0-2.24.93C166,59.86,165.88,60.27,166,60.45Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.86200046539307px 59.53055202960968px',
          }}
          id="elkp7ssnbv6pl"
          className="animable"
        />
        <path
          d="M171.59,43.58c-.73,1.53,2.25,4.35,3.86,4.89s3.67.26,4.54,1.71c1,1.65-1,4.31,2.32,6.11,1.05.57,2.6-.62,3.48.19,1.09,1-.33,2.73-.29,4.2.09,2.88,5.33,3.1,5.67,6,.22,1.79-1.78,3.5-1.08,5.16s3.57,1.56,4.28,3.26c.91,2.19-2.79,4.09-2.33,6.41s4.32,2.3,5.09,4.52c.66,1.89-1.47,4-.74,5.83.82,2.14,4.43,1.83,5.4,3.9,1.17,2.51-2.8,5.4-1.45,7.81.45.81,1.48,1.09,2.09,1.79,2,2.26,1.78,7.18-.25,9.15l1.45,0a13.18,13.18,0,0,0,10.89-6.08h0l1.2,2.79c3.86-1.22,6.87-3.75,10-6.35a6.24,6.24,0,0,1,5.62-1.23l.85.24c2.58.19,6-1.09,8.13-2.53-2.85-.57-4.38-3.68-5.09-6.5s-1.14-6-3.27-7.93c-2.31-2.14-6.3-2.62-7.37-5.58-.83-2.33.72-5,0-7.33s-3.55-3.55-4.63-5.8c-1.47-3.06.65-7.11-1.22-10-2-3.08-7.47-2.63-9-6-.85-1.86-.16-4.38-1.63-5.8-1.17-1.13-3.17-.95-4.41-2-1.8-1.57-.92-4.79-2.49-6.59-2.13-2.44-6.49-.29-9.22-2-1.72-1.1-2.29-3.45-4-4.57-2.31-1.53-5.33-.15-7.94.76-2,.7-4.14,1.11-6.1,2a7.83,7.83,0,0,0-4.5,4.31c-.7,2,.17,4.64,2.2,5.33"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '204.7655487060547px 72.53714942932129px',
          }}
          id="ell16898pya6p"
          className="animable"
        />
        <path
          d="M236.49,91.44l.2.18c.13.12.33.31.57.56a7.33,7.33,0,0,1,.82,1,3.85,3.85,0,0,1,.67,1.64,2.73,2.73,0,0,1-.65,2.1,1.73,1.73,0,0,1-2.47.23,4.23,4.23,0,0,1-1.17-2.78,29.66,29.66,0,0,1,0-3.39c0-1.19.16-2.42.33-3.71.08-.64.19-1.29.3-2a7.92,7.92,0,0,0,.12-2,2.19,2.19,0,0,0-.91-1.69,3.33,3.33,0,0,0-2-.37,16.76,16.76,0,0,1-2.27.11,2.78,2.78,0,0,1-2.14-1,4,4,0,0,1-.74-2.32,11.8,11.8,0,0,1,.19-2.45,8.93,8.93,0,0,0,.07-2.42,2.92,2.92,0,0,0-1.16-2A13.35,13.35,0,0,0,224,70a4.38,4.38,0,0,1-2-1.79,10.46,10.46,0,0,1-.85-5.3,15.49,15.49,0,0,0-.13-2.65,5.34,5.34,0,0,0-.93-2.37c-1-1.36-2.74-2-4.28-2.66A11.69,11.69,0,0,1,213.56,54,4.23,4.23,0,0,1,212,52a13.22,13.22,0,0,1-.36-2.43,3,3,0,0,0-.86-2,4.15,4.15,0,0,0-2-.82,11.62,11.62,0,0,1-2.22-.55,3,3,0,0,1-1.63-1.54,6.38,6.38,0,0,1-.44-2.12,8.92,8.92,0,0,0-.7-3.86,5.36,5.36,0,0,0-2.78-2.2,10.34,10.34,0,0,0-3.26-.63c-1.06,0-2.06,0-3-.08a13.86,13.86,0,0,1-2.61-.3,7.33,7.33,0,0,1-2.06-.83,4.88,4.88,0,0,1-2.08-2.2,3,3,0,0,1-.27-1,6.59,6.59,0,0,0,.34,1,4.83,4.83,0,0,0,2.08,2.11,7.4,7.4,0,0,0,2,.78,14.49,14.49,0,0,0,2.58.27c.94,0,1.94,0,3,0a10.61,10.61,0,0,1,3.34.62A5.5,5.5,0,0,1,204,38.5a9,9,0,0,1,.76,4,6,6,0,0,0,.42,2,2.71,2.71,0,0,0,1.48,1.38,11.08,11.08,0,0,0,2.15.51,4.55,4.55,0,0,1,2.2.9,3.38,3.38,0,0,1,1,2.23,12.91,12.91,0,0,0,.35,2.36,3.86,3.86,0,0,0,1.4,1.87A10.9,10.9,0,0,0,216,54.92c.77.35,1.57.67,2.34,1.1a6.11,6.11,0,0,1,2.08,1.68,5.77,5.77,0,0,1,1,2.52,17.65,17.65,0,0,1,.14,2.72,9.89,9.89,0,0,0,.8,5.12,3.9,3.9,0,0,0,1.84,1.63,14.84,14.84,0,0,1,2.32,1.17,3.28,3.28,0,0,1,1.3,2.25,9.21,9.21,0,0,1-.08,2.52A12.12,12.12,0,0,0,227.5,78a3.78,3.78,0,0,0,.66,2.13,2.52,2.52,0,0,0,1.91.91,20.73,20.73,0,0,0,2.22-.1,3.56,3.56,0,0,1,2.21.42,2.5,2.5,0,0,1,1,1.92,7.85,7.85,0,0,1-.14,2.07c-.11.67-.22,1.31-.3,2-.18,1.27-.29,2.5-.36,3.68s-.11,2.31-.05,3.35A4.12,4.12,0,0,0,235.76,97a1.64,1.64,0,0,0,1.19.36,1.66,1.66,0,0,0,1-.55,2.62,2.62,0,0,0,.63-2,3.81,3.81,0,0,0-.62-1.59,8.37,8.37,0,0,0-.78-1l-.54-.58C236.55,91.52,236.48,91.45,236.49,91.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '213.2489128112793px 64.50210189819336px',
          }}
          id="eldcd2ghg8y46"
          className="animable"
        />
        <path
          d="M209.54,109.27a1.79,1.79,0,0,1,.34-.15,9.29,9.29,0,0,0,1-.44,3.72,3.72,0,0,0,1.32-1.05,2.12,2.12,0,0,0,.25-2.14,1.7,1.7,0,0,0-1-.76c-.46-.15-1-.21-1.49-.39a1.82,1.82,0,0,1-.74-.44,1.34,1.34,0,0,1-.36-.83,3.58,3.58,0,0,1,.62-1.73,3.91,3.91,0,0,0,.61-1.75,3.7,3.7,0,0,0-.36-1.92,3.59,3.59,0,0,0-3.53-1.89l-.15,0v-.15a5,5,0,0,1,1-3.08,18.53,18.53,0,0,0,1.78-2.84,4.38,4.38,0,0,0,.39-1.64,2.32,2.32,0,0,0-.52-1.56c-.75-.88-2-1.09-3.21-1.62a2.86,2.86,0,0,1-1.48-1.33,2.71,2.71,0,0,1,0-2c.41-1.27,1.24-2.41,1.2-3.7a2.92,2.92,0,0,0-.75-1.72,6.15,6.15,0,0,0-1.54-1.27,28.16,28.16,0,0,1-3.63-2.11,3.72,3.72,0,0,1-1.42-2.24,5.55,5.55,0,0,1,.25-2.6c.23-.82.52-1.61.68-2.41a4.7,4.7,0,0,0,.09-1.18,2.44,2.44,0,0,0-.37-1.08A3.39,3.39,0,0,0,196.54,62a12.9,12.9,0,0,1-2.24-.89,2.85,2.85,0,0,1-1.41-1.94,5.85,5.85,0,0,1,.14-2.33c.15-.74.34-1.46.43-2.17a4.07,4.07,0,0,0-.18-2.06A3.35,3.35,0,0,0,192,51.1a7,7,0,0,0-1.83-.76c-1.27-.34-2.59-.44-3.78-.88a5.11,5.11,0,0,1-1.62-.93,4.71,4.71,0,0,1-1.07-1.42c-.54-1-.83-2.08-1.26-3a5.36,5.36,0,0,0-1.74-2.2,5.26,5.26,0,0,0-4.32-.94,5.56,5.56,0,0,0-2.54,1.32c-.49.46-.68.76-.7.75a3.87,3.87,0,0,1,.65-.8,5.52,5.52,0,0,1,2.56-1.41,5.44,5.44,0,0,1,4.47.91A5.62,5.62,0,0,1,182.62,44c.45.93.75,2,1.27,3a4.62,4.62,0,0,0,1,1.34,4.54,4.54,0,0,0,1.54.86c1.15.42,2.44.52,3.76.86a7.21,7.21,0,0,1,1.92.79,3.59,3.59,0,0,1,1.43,1.62,4.41,4.41,0,0,1,.21,2.22c-.09.74-.28,1.46-.43,2.19a5.87,5.87,0,0,0-.13,2.2,2.5,2.5,0,0,0,1.25,1.71,14.25,14.25,0,0,0,2.19.86,3.79,3.79,0,0,1,2.05,1.42,2.74,2.74,0,0,1,.42,1.24,5,5,0,0,1-.09,1.28c-.17.84-.46,1.63-.69,2.44a5.33,5.33,0,0,0-.24,2.43,3.4,3.4,0,0,0,1.3,2A28.73,28.73,0,0,0,203,74.56a6.78,6.78,0,0,1,1.63,1.34,3.26,3.26,0,0,1,.82,1.94c0,1.48-.84,2.63-1.21,3.82a2.36,2.36,0,0,0,0,1.77,2.53,2.53,0,0,0,1.3,1.17c.56.26,1.16.44,1.74.67a4,4,0,0,1,1.59,1,2.65,2.65,0,0,1,.58,1.78,4.73,4.73,0,0,1-.41,1.76,18.6,18.6,0,0,1-1.82,2.88,4.7,4.7,0,0,0-1,2.89l-.16-.13a3.81,3.81,0,0,1,3.79,2.06,3.94,3.94,0,0,1-.27,3.89,3.46,3.46,0,0,0-.61,1.61,1.25,1.25,0,0,0,.94,1.09c.49.18,1,.25,1.48.4a1.74,1.74,0,0,1,1.3,2.12,2.42,2.42,0,0,1-.45,1,3.74,3.74,0,0,1-1.38,1.06A7.31,7.31,0,0,1,209.54,109.27Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '192.9411849975586px 74.97722625732422px',
          }}
          id="eli1dq8oxineb"
          className="animable"
        />
        <path
          d="M229.36,102.82a4.8,4.8,0,0,0,.51-1,4,4,0,0,0-.2-3,3.5,3.5,0,0,0-1.54-1.56,10.07,10.07,0,0,1-1.11-.7,1.88,1.88,0,0,1-.76-1.22c-.15-1,.58-2,.56-3a1.76,1.76,0,0,0-.73-1.35,7.41,7.41,0,0,0-1.56-.81,7.07,7.07,0,0,1-1.67-.92,2.72,2.72,0,0,1-1-1.74c-.22-1.38.22-2.76.24-4.16a3.4,3.4,0,0,0-.5-2,3.91,3.91,0,0,0-1.76-1.22,18.93,18.93,0,0,1-2.17-.91,2.71,2.71,0,0,1-1.48-1.95,8.91,8.91,0,0,1,.12-2.48,2.92,2.92,0,0,0-.44-2.27,5,5,0,0,0-2.13-1.2,4.3,4.3,0,0,1-2.22-1.49,3.94,3.94,0,0,1-.47-2.68,16.58,16.58,0,0,1,.67-2.65,7,7,0,0,0,.35-2.63,3,3,0,0,0-1.34-2.15,7.74,7.74,0,0,0-2.55-.89c-.89-.18-1.81-.32-2.69-.58a5.18,5.18,0,0,1-2.42-1.34,6.26,6.26,0,0,1-1.38-2.34c-.54-1.71-.69-3.45-1-5.08a9.41,9.41,0,0,0-.79-2.33,4.46,4.46,0,0,0-1.61-1.67c-1.4-.75-3-.55-4.55-.48a11,11,0,0,1-2.29-.07,4.71,4.71,0,0,1-2.07-.87,14.65,14.65,0,0,1-2.6-3.28,8.83,8.83,0,0,0-1.25-1.46,6.87,6.87,0,0,0-1.53-1,8.78,8.78,0,0,0-6.35-.37,12.61,12.61,0,0,0-4.27,2.41,19.26,19.26,0,0,0-2.23,2.21l-.53.62-.19.21s.05-.08.16-.23.27-.37.5-.65a19.4,19.4,0,0,1,2.19-2.27,12.76,12.76,0,0,1,4.31-2.5,9,9,0,0,1,6.52.34,7.3,7.3,0,0,1,1.6,1,8.92,8.92,0,0,1,1.3,1.5,14,14,0,0,0,2.56,3.2,4.25,4.25,0,0,0,1.93.8,10.33,10.33,0,0,0,2.23.06c.76,0,1.54-.1,2.34-.07a5.44,5.44,0,0,1,2.38.57A4.83,4.83,0,0,1,200.16,47,10.11,10.11,0,0,1,201,49.4c.36,1.67.51,3.4,1,5.05a5.82,5.82,0,0,0,1.29,2.2,5,5,0,0,0,2.27,1.25c.85.25,1.76.39,2.66.57a8,8,0,0,1,2.68.93,3.38,3.38,0,0,1,1.5,2.42,7.32,7.32,0,0,1-.36,2.77,15.63,15.63,0,0,0-.66,2.59,3.59,3.59,0,0,0,.41,2.45A3.91,3.91,0,0,0,213.87,71a5.27,5.27,0,0,1,2.27,1.31,2.53,2.53,0,0,1,.52,1.24,5.47,5.47,0,0,1,0,1.28,9.38,9.38,0,0,0-.13,2.4,2.42,2.42,0,0,0,1.31,1.72,21.25,21.25,0,0,0,2.13.9,4.14,4.14,0,0,1,1.89,1.33,3.6,3.6,0,0,1,.55,2.18c0,1.46-.47,2.83-.27,4.11A2.46,2.46,0,0,0,223,89a6.49,6.49,0,0,0,1.61.89,7.48,7.48,0,0,1,1.6.86,2,2,0,0,1,.81,1.53c0,1.17-.73,2.08-.59,3a1.69,1.69,0,0,0,.68,1.11,8.94,8.94,0,0,0,1.08.69,3.67,3.67,0,0,1,1.58,1.65,4,4,0,0,1,.14,3.1A2.81,2.81,0,0,1,229.36,102.82Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '200.29347229003906px 70.06786727905273px',
          }}
          id="elmx2g00nebhk"
          className="animable"
        />
        <path
          d="M179.33,83.13a2.22,2.22,0,0,1,2.74-3.3,3.52,3.52,0,0,1,1.36,1.27,2.38,2.38,0,0,1,.51,1.83,1.9,1.9,0,0,1-1,1.16,3,3,0,0,1-2.36.2A2.59,2.59,0,0,1,179,82.58"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '181.4420895576477px 82.03486800193787px',
          }}
          id="el91dhfz7lr8"
          className="animable"
        />
        <path
          d="M183.32,79.49c.14,0,.2.45,0,1.07a4.3,4.3,0,0,1-3.89,2.87c-.65,0-1-.17-1-.31,0-.3,1.46-.42,2.76-1.4S183,79.41,183.32,79.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '180.93924570083618px 81.45827317237854px',
          }}
          id="el8gfd1eiuvug"
          className="animable"
        />
        <path
          d="M236.14,120l-5.62-8.86-.39-8.72,2.21-6s1.76-.42,2,1.68a11.36,11.36,0,0,1-.66,4.64l1.21,4.23s.4.46.77-1.3-.28-14.8-.28-15.7.06-3,1.39-2.84,1.75,2,1.76,2.86,1,9.65,1,9.65.31.79.62.67-.27-9.39-.34-10.86-.38-4.71,1.34-4.72,1.72,1.63,1.81,3.43,1.22,11.83,1.22,11.83.26.63.51-.21.55-11.77.75-12.28,1.19-1.18,2,.05.59,4.12.48,9.21c-.09,4.59-.24,6.49.29,6.85s2.46-2.46,2.46-2.46,2.35-6,4.34-5.83.65,1.76.31,3.16c-.29,1.19-3.77,8.29-3.84,8.35S248,119.59,248,119.59l8.86,16.95c1.31,2.52,1.15,4.73.74,7.54-.45,3.09-2.63,4.66-7.14,6.07-3.34,1-6.9.08-8.52-1.68a9.84,9.84,0,0,1-2.47-5.3c-1-5.56-3.31-23.14-3.31-23.14Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '244.01206302642822px 117.64605712890625px',
          }}
          id="elu8vvnqil8ka"
          className="animable"
        />
        <path
          d="M241.76,113.67c-.08,0,0-.67-.18-1.7a6.79,6.79,0,0,0-1.83-3.54,4.78,4.78,0,0,0-2.84-1.45,2.93,2.93,0,0,0-1.93.44l-.08,0,0-.07c-.12-.24-.16-.37-.14-.38s.11.09.27.3l-.12,0a2.77,2.77,0,0,1,2.06-.67,4.87,4.87,0,0,1,3.11,1.49,6.48,6.48,0,0,1,1.83,3.8A3.47,3.47,0,0,1,241.76,113.67Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '238.35942888259888px 110.12972950935364px',
          }}
          id="elcz3lm9apu6n"
          className="animable"
        />
        <path
          d="M246.51,107c.08.11-.68.76-1.43,1.73s-1.2,1.86-1.32,1.81a5.25,5.25,0,0,1,2.75-3.54Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '245.1378993988037px 108.77100610733032px',
          }}
          id="el6ftouxym444"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-1--inject-103"
        style={{ transformOrigin: '186.79329681396484px 325.1044464111328px' }}
        className="animable"
      >
        <g id="el5264y9lsjs4">
          <ellipse
            cx="177.82"
            cy="345.42"
            rx="55.36"
            ry="59.92"
            style={{
              fill: 'rgb(250, 250, 250)',
              transformOrigin: '177.82px 345.42px',
              transform: 'rotate(-19.78deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M125.73,364.15s-.46-1.18-1.19-3.48a62.79,62.79,0,0,1-2.22-10.32c-.19-1.14-.24-2.35-.38-3.62s-.16-2.61-.14-4a60.51,60.51,0,0,1,7.63-30,55.26,55.26,0,0,1,7.59-10.4,52.73,52.73,0,0,1,10.79-8.87,52,52,0,0,1,29.46-7.69,56.59,56.59,0,0,1,31.57,11.6,64.17,64.17,0,0,1,23.48,65.28,56.59,56.59,0,0,1-17,29.05,52,52,0,0,1-27.61,12.84,53.06,53.06,0,0,1-14,0,55.13,55.13,0,0,1-12.48-3.19,60.24,60.24,0,0,1-25-18.24c-.9-1.07-1.67-2.16-2.44-3.18s-1.43-2-2-3a63.54,63.54,0,0,1-4.86-9.38c-.91-2.23-1.3-3.44-1.3-3.44s.13.29.36.86.54,1.44,1,2.54a65.37,65.37,0,0,0,4.93,9.31c.58,1,1.32,1.94,2,3s1.54,2.1,2.44,3.15a59.71,59.71,0,0,0,6.24,6.55,58.77,58.77,0,0,0,18.67,11.51,55.21,55.21,0,0,0,12.4,3.13,52.69,52.69,0,0,0,13.85-.06A51.57,51.57,0,0,0,215,391.38a56.15,56.15,0,0,0,16.78-28.82,63.68,63.68,0,0,0-23.29-64.75,56.2,56.2,0,0,0-31.28-11.53A51.64,51.64,0,0,0,148,293.86a52.68,52.68,0,0,0-10.71,8.77,55.36,55.36,0,0,0-7.57,10.31,58.86,58.86,0,0,0-7.06,20.76,59.67,59.67,0,0,0-.65,9c0,1.39.08,2.72.13,4s.17,2.47.35,3.6a66.44,66.44,0,0,0,2.12,10.32c.32,1.16.64,2,.82,2.62S125.73,364.15,125.73,364.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '177.87258529663086px 345.3641777038574px',
          }}
          id="elxkirks73lq"
          className="animable"
        />
        <path
          d="M116.59,367.44s-.54-1.41-1.4-4.15A75.65,75.65,0,0,1,112.56,351c-.22-1.35-.29-2.79-.44-4.3s-.2-3.09-.18-4.75a71.3,71.3,0,0,1,.72-10.77A70,70,0,0,1,121,306.38,65.43,65.43,0,0,1,130,294a63.05,63.05,0,0,1,12.81-10.53,61.83,61.83,0,0,1,35-9.13,67.2,67.2,0,0,1,37.49,13.78,76.17,76.17,0,0,1,27.89,77.53,67.27,67.27,0,0,1-20.14,34.5,61.74,61.74,0,0,1-32.79,15.25,63.06,63.06,0,0,1-16.58,0,65.29,65.29,0,0,1-14.82-3.79A71.73,71.73,0,0,1,129.22,390c-1.07-1.26-2-2.57-2.9-3.77s-1.7-2.42-2.39-3.6a75.34,75.34,0,0,1-5.78-11.13c-1.08-2.65-1.56-4.08-1.56-4.08s.15.34.43,1,.64,1.72,1.23,3a78.21,78.21,0,0,0,5.85,11.07c.69,1.17,1.57,2.31,2.41,3.57s1.83,2.49,2.9,3.75a71.86,71.86,0,0,0,7.42,7.79A69.94,69.94,0,0,0,159,411.34a65.76,65.76,0,0,0,14.74,3.73,62.26,62.26,0,0,0,16.47-.07,61.32,61.32,0,0,0,32.53-15.18,66.72,66.72,0,0,0,20-34.26,75.72,75.72,0,0,0-27.69-77,66.76,66.76,0,0,0-37.21-13.71,61.34,61.34,0,0,0-34.74,9,62.14,62.14,0,0,0-12.74,10.43,65,65,0,0,0-9,12.27,69.74,69.74,0,0,0-8.4,24.68,71,71,0,0,0-.76,10.72c0,1.66.09,3.24.15,4.75s.21,2.94.42,4.28a77.06,77.06,0,0,0,2.53,12.26c.38,1.38.76,2.41,1,3.11S116.59,367.44,116.59,367.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '178.53404235839844px 345.1167755126953px',
          }}
          id="el50f0kh7iumd"
          className="animable"
        />
        <path
          d="M194.75,268.25c.2-.1,8-3,8.35,5.14s-7.93,6.82-7.95,6.59S194.75,268.25,194.75,268.25Z"
          style={{
            fill: 'rgb(197, 137, 132)',
            transformOrigin: '198.93039894104004px 273.93284034729004px',
          }}
          id="elz3l9gzse3sq"
          className="animable"
        />
        <path
          d="M197.51,276.78s.15.09.4.19a1.38,1.38,0,0,0,1.06,0c.85-.35,1.52-1.75,1.5-3.22a4.63,4.63,0,0,0-.49-2,1.63,1.63,0,0,0-1.11-1,.72.72,0,0,0-.82.43c-.1.23-.05.39-.09.41s-.18-.13-.13-.47a1,1,0,0,1,.3-.53,1.08,1.08,0,0,1,.78-.24,2,2,0,0,1,1.54,1.2,4.86,4.86,0,0,1,.59,2.26c0,1.65-.77,3.22-1.93,3.61a1.54,1.54,0,0,1-1.31-.16C197.54,277,197.49,276.8,197.51,276.78Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '199.2730209827423px 273.9222707748413px',
          }}
          id="el2d9mw7sttl"
          className="animable"
        />
        <path
          d="M154.38,287.21c-.5-5.75-.55-17.67-.48-28.46a22.25,22.25,0,0,1,20.63-22l1.14-.09c12.45-.18,19.56,10.28,19.41,22.73l1.21,41-13.94,3.23a8.92,8.92,0,0,1-1.36.2l-13.29.9-.25-4.6S155.4,299.11,154.38,287.21Z"
          style={{
            fill: 'rgb(197, 137, 132)',
            transformOrigin: '175.08238410949707px 270.6888732910156px',
          }}
          id="elbl09md44rh"
          className="animable"
        />
        <path
          d="M160.2,267.69a1.69,1.69,0,0,0,1.76,1.6,1.63,1.63,0,0,0,1.64-1.66,1.7,1.7,0,0,0-1.76-1.6A1.63,1.63,0,0,0,160.2,267.69Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '161.89999639987946px 267.66016352176666px',
          }}
          id="el7uot7bm845"
          className="animable"
        />
        <path
          d="M178.12,265.56a1.69,1.69,0,0,0,1.76,1.59,1.64,1.64,0,0,0,1.65-1.66,1.72,1.72,0,0,0-1.77-1.6A1.63,1.63,0,0,0,178.12,265.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '179.8248153924942px 265.5203537940979px',
          }}
          id="elhsqa9l0ta8"
          className="animable"
        />
        <path
          d="M156.82,264.92c.22.21,1.44-.84,3.27-1s3.24.69,3.43.45-.16-.49-.77-.87a4.62,4.62,0,0,0-2.76-.64,4.5,4.5,0,0,0-2.59,1.05C156.87,264.42,156.71,264.83,156.82,264.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '160.17949199676514px 263.8957408666611px',
          }}
          id="el7utw86af5l"
          className="animable"
        />
        <path
          d="M175.19,263.15c.24.19,1.4-.93,3.21-1.18s3.28.48,3.45.23-.19-.48-.83-.82a4.69,4.69,0,0,0-2.79-.46,4.52,4.52,0,0,0-2.52,1.21C175.21,262.64,175.08,263.06,175.19,263.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '178.52281093597412px 262.0219393968582px',
          }}
          id="el8seiw044zck"
          className="animable"
        />
        <path
          d="M169.27,277.48a11.88,11.88,0,0,0-3-.32c-.47,0-.92-.07-1-.39a2.37,2.37,0,0,1,.21-1.4l1.12-3.67c1.55-5.2,2.63-9.47,2.42-9.53s-1.63,4.11-3.18,9.32c-.37,1.28-.73,2.51-1.06,3.68a2.69,2.69,0,0,0-.11,1.85,1.17,1.17,0,0,0,.82.63,3.89,3.89,0,0,0,.8.05A12.44,12.44,0,0,0,169.27,277.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '166.9129650592804px 269.9414324760437px',
          }}
          id="el2ede2u7rgvl"
          className="animable"
        />
        <path
          d="M174.75,278.35c-.3,0-.16,2-1.76,3.53s-3.73,1.47-3.72,1.75c0,.12.5.35,1.39.31a5,5,0,0,0,3.12-1.35,4.26,4.26,0,0,0,1.34-2.95C175.14,278.8,174.88,278.33,174.75,278.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '172.19553232192993px 281.1470081806183px',
          }}
          id="eloj4xxbm3ggp"
          className="animable"
        />
        <path
          d="M173.93,255.88c.25.47,2,0,4.19-.13s4,.23,4.2-.26c.09-.23-.28-.65-1-1a7.1,7.1,0,0,0-3.23-.58,7,7,0,0,0-3.16.88C174.14,255.21,173.81,255.66,173.93,255.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '178.1196632385254px 254.99172031879425px',
          }}
          id="ela063pm6tons"
          className="animable"
        />
        <path
          d="M156.8,260c.35.39,1.58-.13,3.1-.27s2.82.08,3.08-.38c.12-.22-.12-.62-.71-1a4.48,4.48,0,0,0-5,.52C156.79,259.36,156.64,259.8,156.8,260Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '159.87422919273376px 258.98046720027924px',
          }}
          id="ela17y8x1dvlk"
          className="animable"
        />
        <path
          d="M186.23,262.9c.05.07-.47.53-1.24.88a2.58,2.58,0,0,1-1.48.35,6.12,6.12,0,0,1,1.34-.65A5.54,5.54,0,0,1,186.23,262.9Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '184.8716537952423px 263.5178726911545px',
          }}
          id="el7j0bbq28ki8"
          className="animable"
        />
        <path
          d="M187.62,264.63a5.11,5.11,0,0,1-1.78.14,4.92,4.92,0,0,1-1.78-.17,4.93,4.93,0,0,1,1.78-.15A5.05,5.05,0,0,1,187.62,264.63Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '185.83999633789062px 264.61018842458725px',
          }}
          id="eli1td9zx9wfp"
          className="animable"
        />
        <path
          d="M174.07,249.42c0,.05-.56.21-1.43.62s-2,1.06-3.35,1.73a9.43,9.43,0,0,1-3.66,1.08,4.67,4.67,0,0,1-1.16-.08c-.27-.05-.41-.11-.4-.13s.6.08,1.55,0a10.85,10.85,0,0,0,3.52-1.14c1.31-.66,2.49-1.31,3.41-1.66A4.41,4.41,0,0,1,174.07,249.42Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '169.0697546005249px 251.13865292072296px',
          }}
          id="el7wea5s7w5wv"
          className="animable"
        />
        <path
          d="M171.64,249.28a8.56,8.56,0,0,1-3.56,1.43,8.8,8.8,0,0,1-3.83.08c0-.1,1.72,0,3.77-.4A35.79,35.79,0,0,0,171.64,249.28Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '167.94499969482422px 250.12141984701157px',
          }}
          id="elcb657ekh1x6"
          className="animable"
        />
        <path
          d="M177.07,278.68c-.08.05-.4-.64-1.19-.9a3.44,3.44,0,0,0-1.5,0s.11-.18.4-.29a1.8,1.8,0,0,1,2.14.71C177.09,278.47,177.11,278.67,177.07,278.68Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '175.73376166820526px 278.0296039581299px',
          }}
          id="el8gtbgyzufli"
          className="animable"
        />
        <path
          d="M178.6,278.22c-.09,0-.32-.74-1.12-1.18a3.81,3.81,0,0,0-1.58-.36s.16-.15.49-.19a2.05,2.05,0,0,1,1.25.27,2,2,0,0,1,.87.94C178.64,278,178.63,278.21,178.6,278.22Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '177.2595192193985px 277.3494328856468px',
          }}
          id="el6ighku6onyq"
          className="animable"
        />
        <path
          d="M197.1,246.81a5.79,5.79,0,0,0-3.48-7.37c.76-1.16-.3-2.73-1.56-3.28s-2.72-.57-4-1.18a19.79,19.79,0,0,1-2.4-1.71,7.91,7.91,0,0,0-7.93-.51c-.58-1.86-2.71-2.89-4.67-2.85a13.61,13.61,0,0,0-5.54,1.78,13.52,13.52,0,0,0-6-2,7.29,7.29,0,0,0-5.76,2.18,5.06,5.06,0,0,0-.67,5.9,5.2,5.2,0,0,0-2.65,9.6,4.54,4.54,0,0,0,.45,5.1c1.19,1.38,1.91,0,1.91,0l2.94-4.36a18.68,18.68,0,0,0,3.42-.08,13,13,0,0,0,5.43-1.41,19.17,19.17,0,0,0,2.84-2.26,30.94,30.94,0,0,1,3-2.3,12.85,12.85,0,0,1,10.84.41c3.38,1.66,6.19,6.47,6.8,10.56a117.21,117.21,0,0,1,1.46,16.51c0,1.64.25,3.7,1.81,4.22A2,2,0,0,0,196.1,272a34.24,34.24,0,0,0,.05-4.14l1.24-.17c.91-5.57.18-10.62-.58-16.21a23.05,23.05,0,0,0-.7-3.22A4.31,4.31,0,0,0,197.1,246.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '173.91085243225098px 251.79037284851074px',
          }}
          id="eld786eczuegt"
          className="animable"
        />
        <path
          d="M186.53,240.72a13.68,13.68,0,0,0-8-3.28,12.62,12.62,0,0,0-7.18,1.39,8.49,8.49,0,0,0-4.28,5.76l-8.66,2.34a10.32,10.32,0,0,0,13.33-3.12,9.56,9.56,0,0,0,9,.05,10.47,10.47,0,0,0,9.18,4.7A10.07,10.07,0,0,0,186.53,240.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '174.16725540161133px 242.97129487991333px',
          }}
          id="el48lfpyiujm4"
          className="animable"
        />
        <path
          d="M161.66,247.94a1.66,1.66,0,0,1-.75-.11,4.21,4.21,0,0,1-1.77-1.13,4.11,4.11,0,0,1-1.14-3A4.45,4.45,0,0,1,160,240.2l.08.46a4.42,4.42,0,0,1-2.69-1.92,4.13,4.13,0,0,1,.31-5,4.11,4.11,0,0,1,3.9-1.5A2.73,2.73,0,0,1,163,233a2.17,2.17,0,0,1,.54,1.13,1.24,1.24,0,0,1-.18,1,3.06,3.06,0,0,0,0-1,2.22,2.22,0,0,0-1.89-1.6A3.75,3.75,0,0,0,158,234a3.87,3.87,0,0,0-.86,2.1,3.76,3.76,0,0,0,.62,2.34,4,4,0,0,0,2.36,1.71l.58.13-.5.32a4.1,4.1,0,0,0-1.79,3.11,3.89,3.89,0,0,0,.95,2.75A5.28,5.28,0,0,0,161.66,247.94Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '160.13456773757935px 240.0646653175354px',
          }}
          id="elgzryhhkfau"
          className="animable"
        />
        <path
          d="M196.68,251.17a7.45,7.45,0,0,1-6.68,1c0-.15,1.55.07,3.39-.23S196.61,251,196.68,251.17Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '193.3399887084961px 251.84719794988632px',
          }}
          id="elp6wl2in5jwj"
          className="animable"
        />
        <path
          d="M197.5,253.63a6.7,6.7,0,0,1-6.66,1.85,32.43,32.43,0,0,0,3.45-.5A33.07,33.07,0,0,0,197.5,253.63Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '194.1699981689453px 254.6773806810379px',
          }}
          id="el1rcxidbrv0xj"
          className="animable"
        />
        <path
          d="M167.43,300.08a27.79,27.79,0,0,0,15.21-5.55s-2.95,9-14.91,8.77Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '175.03500366210938px 298.91716051101685px',
          }}
          id="el36qxd4uue36"
          className="animable"
        />
        <path
          d="M206.12,309.08,199.21,307l-.88-5.61a1.8,1.8,0,0,0-2.05-1.68l-31.08,4.37a1.81,1.81,0,0,0-1.53,2.09v4.38l-24.25,10.19s-2.74,10.8-2,20.12c.57,7.2,3.13,48.36,3.13,48.36s17.1,16.81,37.16,17.28a58.86,58.86,0,0,0,40.9-15.7c0-.48,4.59-49.67,4.59-49.67l2.52-23.45Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '181.5066032409668px 353.0993194580078px',
          }}
          id="elx5syxfme1as"
          className="animable"
        />
        <path
          d="M140.56,389.19l-1.13-68.48s-12.26,9.34-14.86,41.89C124.57,362.6,131.82,381.42,140.56,389.19Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '132.56499481201172px 354.9499969482422px',
          }}
          id="elwk2p5bonrgj"
          className="animable"
        />
        <path
          d="M222.13,316.13s11.26,3.44,14.55,12.55,27.32,46,29.15,49.33c5.58,10,.32,24.06-8.08,26.5s-44.27-15.24-44.95-17.34a21,21,0,0,1-.5-5.86L214.51,367l6.16,1.41Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '240.20282363891602px 360.43531036376953px',
          }}
          id="el38cn2ht87ck"
          className="animable"
        />
        <g id="elnmmahznbzl">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '185.5999984741211px 386.4369821548462px',
            }}
            className="animable"
          >
            <path
              d="M208.62,384.85c-.5-.91-.42-3.51-1-4.39-.88-1.45-2.69-.86-4.09-1.83l-6.48-4.49a5.21,5.21,0,0,0-2.29-1.08,3.67,3.67,0,0,0-3.05,1.45,17.05,17.05,0,0,0-1.8,3c-.52,1-1.12.6-2.23.72a14.15,14.15,0,0,1-3.66.26,4,4,0,0,0-3.46,1.65c-.86,1-1.48,2.24-2.41,3.19-2.26,2.32-5.85,2.63-9.08,2.54s-6.67-.37-9.52,1.15c-3.58,1.91-5.2,6.08-6.54,9.91l.54,1.89c3.85,1.66,9.21,1,13.21-.2s8.07-2.79,12.24-2.45c4.42.35,8.92,2.82,13.06,1.23,2.4-.92,4.14-3.05,6.47-4.13,3.07-1.43,6.64-.84,10-.48s7.16.34,9.66-1.95C214.53,389.71,210.47,388.27,208.62,384.85Z"
              id="el3x7aosfjwc"
              style={{
                transformOrigin: '185.5999984741211px 386.4369821548462px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M222.87,393.13a1.11,1.11,0,0,1-.3-.1l-.85-.34-3.22-1.34L207,386.41l-.15-.07,0-.16c.91-6.32,2-14,3.18-22.21,0-.21.06-.43.08-.62l0-.27.28.05c10.6,2.24,20,5,26.75,7,3.38,1,6.09,1.94,8,2.58l2.14.75a4.56,4.56,0,0,1,.74.3,7.36,7.36,0,0,1-.77-.2l-2.17-.66c-1.89-.58-4.61-1.42-8-2.42-6.78-2-16.18-4.62-26.76-6.86l.31-.22-.09.62c-1.21,8.24-2.33,15.88-3.26,22.2l-.13-.23,11.45,5.11,3.17,1.46.83.39A1.27,1.27,0,0,1,222.87,393.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '227.43500518798828px 378.1050109863281px',
          }}
          id="eltmiuo34rs1"
          className="animable"
        />
        <path
          d="M227.7,368.14a9.17,9.17,0,0,1-1.56-1.79,45.21,45.21,0,0,1-5.64-9.91,8.9,8.9,0,0,1-.74-2.25,13.37,13.37,0,0,1,1.08,2.1c.63,1.31,1.53,3.1,2.62,5s2.18,3.61,3,4.82A12.52,12.52,0,0,1,227.7,368.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '223.72999572753906px 361.1650085449219px',
          }}
          id="el937iw8lhdbm"
          className="animable"
        />
        <path
          d="M222.1,318.28a29.74,29.74,0,0,1-.8,3.14,58.61,58.61,0,0,0-1.46,7.65,59.66,59.66,0,0,0-.41,7.77,30.08,30.08,0,0,1,0,3.24,2.54,2.54,0,0,1-.18-.85c-.08-.56-.16-1.37-.22-2.37a45.08,45.08,0,0,1,1.88-15.54c.3-1,.57-1.73.78-2.25A2.62,2.62,0,0,1,222.1,318.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '220.53202164173126px 329.17999267578125px',
          }}
          id="elirrtaxe2an"
          className="animable"
        />
        <path
          d="M147.19,391.24c-.15,0-1.65-9.72-3.35-21.76s-3-21.81-2.84-21.83,1.65,9.72,3.35,21.76S147.33,391.22,147.19,391.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '144.09356832504272px 369.4449768066406px',
          }}
          id="elbbioo1yhm58"
          className="animable"
        />
        <path
          d="M177.32,355.45l13.93.75,18.37,11.55-2.07,13.47a96.08,96.08,0,0,1-9.7-3.65c-1.68-.93-1.55-4-1.55-4L194,374.83s-1.25,3.13-2.22,5.83-3.82,1-3.82,1l-.36-2.83c-1.45,1.51-3.67.2-3.67.2l-1-10.45,3.9-5-4.56.46a27.66,27.66,0,0,0-5.36,4.36c-2.7,2.8-6.66-.22-6.66-.22l7.87-9-1.3.59s-5.11,3.55-7.24,3.67-2.59-2.5-2.59-2.5Z"
          style={{
            fill: 'rgb(197, 137, 132)',
            transformOrigin: '188.30498504638672px 368.8190574645996px',
          }}
          id="elpisuskokr7"
          className="animable"
        />
        <polygon
          points="174.59 367.43 193.78 392.13 155.92 388.32 134.94 362.02 174.59 367.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '164.36000061035156px 377.0749969482422px',
          }}
          id="el2h9p9hatdjy"
          className="animable"
        />
        <path
          d="M155.9,388.52h-.08l-21.34-26.75,40.14,5.47h.08l19.53,25.14Zm-20.49-26.24L156,388.13l37.32,3.76-18.86-24.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '164.35499572753906px 377.0749969482422px',
          }}
          id="el5m4leznqob3"
          className="animable"
        />
        <path
          d="M147.7,395.88a15.63,15.63,0,0,0,7.27,3.25l16.67-5,12.77-5.22a1.05,1.05,0,0,0,.65-1l2.07-1.91s.08-1.33-2-1.87-7.61,1.71-7.91,1.88-4.76,1-4.76,1a65,65,0,0,1,8.89-3.76s1.2-4.89-3.71-3.76a48.76,48.76,0,0,0-10.35,4.08l-3.48,1.71-1.67-.64,1.05-2s5.13-5.62,5.2-5.87,1.36-2,.08-2.74-4.46-.37-5.92,1.26-6.67,7.22-6.67,7.22a6.84,6.84,0,0,0-2.26-.11c-1.71.1-4.08-1.8-4.3-2.4s-.4-3.71-2.13-5.48-4.66-2.54-5.28-1.26c-.11.21-.44.57.11,2.09a9.42,9.42,0,0,0,1.06,2.2l.39,7.05,1.86,4-1.38.08S142.23,391.78,147.7,395.88Z"
          style={{
            fill: 'rgb(197, 137, 132)',
            transformOrigin: '164.4207935333252px 385.877028465271px',
          }}
          id="elcg8yq9oxvre"
          className="animable"
        />
        <path
          d="M197.76,367.56a12.58,12.58,0,0,0-2.75-.35,7.24,7.24,0,0,0-2.86.67,7.37,7.37,0,0,0-2.74,2.28,8.18,8.18,0,0,0-1.35,3.33,16,16,0,0,0-.25,3,19.68,19.68,0,0,1,0,2.81,12.2,12.2,0,0,1-.36-2.8,14.66,14.66,0,0,1,.14-3.09,8.25,8.25,0,0,1,1.41-3.55,7.33,7.33,0,0,1,3-2.41,7,7,0,0,1,3.06-.61,6.38,6.38,0,0,1,2.06.37C197.54,367.38,197.77,367.53,197.76,367.56Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '192.59176778793335px 373.0686321258545px',
          }}
          id="el6miuak7kpmj"
          className="animable"
        />
        <path
          d="M192.1,362.85c0,.16-1.27,0-2.77.27s-2.62.77-2.7.63a5.77,5.77,0,0,1,5.47-.9Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '189.36500549316406px 363.14886754751205px',
          }}
          id="ele9ktinvopiu"
          className="animable"
        />
        <path
          d="M172,366.24a13.75,13.75,0,0,1,1.56-2.15c1-1.3,2.47-3.09,4.13-5.1l.07-.08h.1l1.47-.15c3-.27,5.63-.38,7.57-.4a16.29,16.29,0,0,1,3.13.11,19.58,19.58,0,0,1-3.12.26c-1.93.11-4.6.28-7.53.55l-1.47.14.18-.09c-1.68,2-3.18,3.75-4.27,5A14.32,14.32,0,0,1,172,366.24Z"
          style={{
            fill: 'rgb(156, 102, 100)',
            transformOrigin: '181.0150146484375px 362.28478479385376px',
          }}
          id="elj4lpszda9wg"
          className="animable"
        />
        <path
          d="M200.14,307.39a7.92,7.92,0,0,1-1.25.83,40.33,40.33,0,0,1-3.62,1.9,46.15,46.15,0,0,1-13,3.74,44.91,44.91,0,0,1-7.43.4,29.62,29.62,0,0,1-6-.7,11.77,11.77,0,0,1-3.79-1.58,6.59,6.59,0,0,1-.89-.68c-.18-.17-.27-.27-.26-.28s.43.31,1.26.79a13.05,13.05,0,0,0,3.77,1.39,30.87,30.87,0,0,0,6,.58,48.83,48.83,0,0,0,7.35-.43,49.65,49.65,0,0,0,12.87-3.57c1.57-.68,2.82-1.3,3.67-1.74A9.14,9.14,0,0,1,200.14,307.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '182.01963996887207px 310.8345227241516px',
          }}
          id="el3r4sr1ph9sb"
          className="animable"
        />
        <path
          d="M220.26,323.83s-.16-.07-.46-.24a11,11,0,0,0-1.36-.66,12.91,12.91,0,0,0-5.69-1,23.62,23.62,0,0,0-8.83,2.44,27.38,27.38,0,0,0-9.78,7.12,17,17,0,0,0-3.32,6.18,13.49,13.49,0,0,0-.09,7.51,11.31,11.31,0,0,0,4.82,6.33,8.54,8.54,0,0,0,8.19.53,8.44,8.44,0,0,0,3.39-2.77,7.53,7.53,0,0,0,1-2,8,8,0,0,0,.28-2.24,9.18,9.18,0,0,0-1.3-4.41,11.29,11.29,0,0,0-3.26-3.42,18.18,18.18,0,0,0-19-.43,74.52,74.52,0,0,0-8.44,5.79,31.72,31.72,0,0,1-8.75,4.89,16.39,16.39,0,0,1-9.63.09,15.88,15.88,0,0,1-7.74-5.05,16.66,16.66,0,0,1-3.65-8,12,12,0,0,1,0-4.27,6.57,6.57,0,0,1,1.93-3.67,4.45,4.45,0,0,1,3.85-1,5.47,5.47,0,0,1,3.29,2,6.19,6.19,0,0,1,1.2,3.51,7.57,7.57,0,0,1-.7,3.48,11.21,11.21,0,0,1-4.45,4.73,15.53,15.53,0,0,1-5.44,2.05,17.33,17.33,0,0,1-5,.14,16.9,16.9,0,0,1-4.13-1,15.86,15.86,0,0,1-5-3,12.09,12.09,0,0,1-1.08-1.07c-.24-.26-.35-.4-.35-.4s.48.53,1.5,1.39a16.16,16.16,0,0,0,5,2.87,16.75,16.75,0,0,0,4.09.93,17.21,17.21,0,0,0,5-.18,15.34,15.34,0,0,0,5.32-2,10.93,10.93,0,0,0,4.29-4.6,6.57,6.57,0,0,0-.49-6.59,5,5,0,0,0-3-1.86,4,4,0,0,0-3.49.94,6.14,6.14,0,0,0-1.79,3.43,11.81,11.81,0,0,0,0,4.11,16.22,16.22,0,0,0,3.56,7.78,15.41,15.41,0,0,0,7.52,4.88,15.75,15.75,0,0,0,9.34-.1,31.21,31.21,0,0,0,8.6-4.82,74,74,0,0,1,8.5-5.83,18.69,18.69,0,0,1,19.51.48,11.66,11.66,0,0,1,3.39,3.57,9.54,9.54,0,0,1,1.36,4.65,8.07,8.07,0,0,1-.3,2.4,7.92,7.92,0,0,1-1,2.15,9,9,0,0,1-3.59,2.94,9.44,9.44,0,0,1-4.46.81,9.3,9.3,0,0,1-4.17-1.39,11.67,11.67,0,0,1-5-6.59,14,14,0,0,1,.11-7.75,17.37,17.37,0,0,1,3.42-6.3,27.63,27.63,0,0,1,9.94-7.15,23.87,23.87,0,0,1,9-2.39,12.8,12.8,0,0,1,5.74,1.08,9,9,0,0,1,1.35.72Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '175.50997924804688px 337.55810260772705px',
          }}
          id="el4848ivcz8lq"
          className="animable"
        />
        <path
          d="M243.23,343.14a4.61,4.61,0,0,1-.57.86,22.2,22.2,0,0,1-1.84,2.14,27.62,27.62,0,0,1-3.13,2.77,30.56,30.56,0,0,1-4.35,2.72,31.41,31.41,0,0,1-4.77,1.91,27,27,0,0,1-4.09.89,20.05,20.05,0,0,1-2.81.22,3.82,3.82,0,0,1-1,0c0-.09,1.47-.13,3.79-.53a32.13,32.13,0,0,0,4-1,33.85,33.85,0,0,0,4.67-1.91,34.49,34.49,0,0,0,4.3-2.64,32.7,32.7,0,0,0,3.16-2.65C242.26,344.25,243.15,343.08,243.23,343.14Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '231.94998931884766px 348.910373210907px',
          }}
          id="elnrrn3dzlar"
          className="animable"
        />
        <path
          d="M257,368.41c0,.08-.84-.21-2.19-.45a16.67,16.67,0,0,0-10.4,1.46,21.59,21.59,0,0,1-2,1,6.36,6.36,0,0,1,1.81-1.35,14.7,14.7,0,0,1,10.65-1.5A5.82,5.82,0,0,1,257,368.41Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '249.7050018310547px 368.79364252090454px',
          }}
          id="eldyz1m4ei1ti"
          className="animable"
        />
        <path
          d="M230.17,396.14a2.43,2.43,0,0,1-.25-.53,14.39,14.39,0,0,1-.54-1.6,16.55,16.55,0,0,1-.59-6.17,12.92,12.92,0,0,1,1.16-4.16,10.46,10.46,0,0,1,1.3-2,11.27,11.27,0,0,1,1.87-1.77,9.84,9.84,0,0,1,5.12-1.94,7.9,7.9,0,0,1,2.92.33,4.87,4.87,0,0,1,2.56,1.68,2.35,2.35,0,0,1,.45,1.56,2.48,2.48,0,0,1-.62,1.47,5,5,0,0,1-2.56,1.52,9.51,9.51,0,0,1-5.47-.43,9.82,9.82,0,0,1-4.05-2.87,9,9,0,0,1-1.86-3.89,9.73,9.73,0,0,1,.7-6.13,6.49,6.49,0,0,1,1.26-1.89,18.22,18.22,0,0,0-1.08,2,9.85,9.85,0,0,0-.52,6,8.74,8.74,0,0,0,1.83,3.7,9.47,9.47,0,0,0,3.89,2.69,9,9,0,0,0,5.17.38,4.48,4.48,0,0,0,2.29-1.35,1.9,1.9,0,0,0,.15-2.4,4.45,4.45,0,0,0-2.3-1.49,7.46,7.46,0,0,0-2.73-.31,9.53,9.53,0,0,0-4.87,1.82,10.64,10.64,0,0,0-1.8,1.67,9.75,9.75,0,0,0-1.26,1.94,12.55,12.55,0,0,0-1.18,4,17.3,17.3,0,0,0,.41,6.08C229.92,395.37,230.21,396.12,230.17,396.14Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '236.44725227355957px 382.72998046875px',
          }}
          id="eli7i09ld56fe"
          className="animable"
        />
        <path
          d="M142.3,362.05a16.12,16.12,0,0,1-2.37-.82,45.89,45.89,0,0,0-5.8-1.68,46.47,46.47,0,0,0-6-.85,16.22,16.22,0,0,1-2.51-.22,9.58,9.58,0,0,1,2.53-.14,32,32,0,0,1,11.89,2.54A9.57,9.57,0,0,1,142.3,362.05Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '133.96000289916992px 360.18066024780273px',
          }}
          id="el3imxx2rf8ha"
          className="animable"
        />
        <path
          d="M212.28,388.77a2.09,2.09,0,0,1-.45.35l-1.35.93c-.59.4-1.31.88-2.19,1.37s-1.84,1.13-3,1.68-2.36,1.24-3.73,1.82-2.84,1.2-4.41,1.8a71.25,71.25,0,0,1-10.53,2.9,73.81,73.81,0,0,1-10.85,1.16c-1.68,0-3.28.05-4.77,0s-2.88-.17-4.14-.28-2.4-.28-3.4-.41-1.85-.29-2.55-.43l-1.6-.32a2.28,2.28,0,0,1-.55-.15,3,3,0,0,1,.57,0l1.62.22c.69.11,1.55.25,2.55.34s2.13.27,3.39.33,2.64.21,4.12.22,3.07,0,4.74,0a77.46,77.46,0,0,0,10.78-1.19A74.85,74.85,0,0,0,197,396.27c1.57-.58,3.06-1.12,4.4-1.74s2.61-1.19,3.74-1.75,2.12-1.13,3-1.61,1.62-.92,2.22-1.3l1.4-.83A2.71,2.71,0,0,1,212.28,388.77Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '185.51998901367188px 394.7860870361328px',
          }}
          id="el4w5xn2if9a8"
          className="animable"
        />
        <g id="el500xt332hbg">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '239.01355266571045px 371.21743297576904px',
            }}
            className="animable"
          >
            <path
              d="M250.53,373.18c-1.9-2.35-5.1-3.1-8.07-3.63-5.11-.92-10.32-2.07-15.49-2.55,6.9,3.12,15.47,3.69,22,7.93.5.32,1.12.69,1.64.4C251.36,374.94,251.05,373.82,250.53,373.18Z"
              id="elgci7ck1uqmj"
              style={{
                transformOrigin: '239.01355266571045px 371.21743297576904px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el7qf0mtvaqrr">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '180.01331329345703px 313.5234525203705px',
            }}
            className="animable"
          >
            <path
              d="M195,310.07c.6-.26-9.09,6.46-14.57,6.86A22.63,22.63,0,0,1,165,312.24S177.82,317.58,195,310.07Z"
              id="eldorqdn1880e"
              style={{
                transformOrigin: '180.01331329345703px 313.5234525203705px',
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ConnectedIcon;

ConnectedIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
